{
  "level": "training",
  "source": {
    "spawn": "/home/user/.openclaw/workspace/coding/projects/esoteria-remaster-worktrees/esoteria/tools/re/_iso_cache/TRAINING.E3",
    "objects": "AREAS.E3:training.e3",
    "mesh": "TREES.E3:training.e3"
  },
  "spawn_point": {
    "position": [
      -3483.625,
      -3221.71875,
      1183.25
    ],
    "facing_rad": 3.1432130336761475,
    "look_point": [
      -3483.650390625,
      -3206.0,
      1189.1375732421875
    ],
    "forward": [
      0.0016116570914164186,
      -0.9946158528327942,
      -0.10361775755882263
    ],
    "up": [
      0.00016790063818916678,
      -0.10361797362565994,
      0.9946171641349792
    ]
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3925.00048828125,
      -3585.0,
      1057.0
    ],
    "bbox_max": [
      -3365.11572265625,
      -3072.300048828125,
      1235.0
    ],
    "vertex_count": 740,
    "vertices": [
      [
        -3616.132568359375,
        -3347.5634765625,
        1110.0
      ],
      [
        -3721.9990234375,
        -3335.6806640625,
        1110.0
      ],
      [
        -3514.0,
        -3428.209228515625,
        1220.0
      ],
      [
        -3454.0,
        -3434.94384765625,
        1220.0
      ],
      [
        -3514.0,
        -3406.19677734375,
        1185.0
      ],
      [
        -3454.0,
        -3412.931396484375,
        1185.0
      ],
      [
        -3454.0,
        -3412.931396484375,
        1185.0
      ],
      [
        -3514.0,
        -3406.19677734375,
        1185.0
      ],
      [
        -3514.0,
        -3585.0,
        1185.0
      ],
      [
        -3454.0,
        -3585.0,
        1185.0
      ],
      [
        -3468.629638671875,
        -3405.0,
        1175.0
      ],
      [
        -3454.0,
        -3405.0,
        1172.3890380859375
      ],
      [
        -3468.629638671875,
        -3405.0,
        1175.0
      ],
      [
        -3514.0,
        -3401.411865234375,
        1177.39208984375
      ],
      [
        -3514.0,
        -3405.0,
        1183.09716796875
      ],
      [
        -3514.0,
        -3401.411865234375,
        1177.39208984375
      ],
      [
        -3514.0,
        -3406.19677734375,
        1185.0
      ],
      [
        -3514.0,
        -3405.0,
        1155.0
      ],
      [
        -3454.0,
        -3412.931396484375,
        1185.0
      ],
      [
        -3454.0,
        -3406.64208984375,
        1175.0
      ],
      [
        -3454.0,
        -3406.64208984375,
        1175.0
      ],
      [
        -3454.0,
        -3405.0,
        1155.0
      ],
      [
        -3454.0,
        -3405.0,
        1172.3890380859375
      ],
      [
        -3514.0,
        -3585.0,
        1155.0
      ],
      [
        -3454.0,
        -3585.0,
        1155.0
      ],
      [
        -3454.0,
        -3434.94384765625,
        1220.0
      ],
      [
        -3454.0,
        -3412.931396484375,
        1185.0
      ],
      [
        -3514.0,
        -3406.19677734375,
        1185.0
      ],
      [
        -3514.0,
        -3428.209228515625,
        1220.0
      ],
      [
        -3568.378662109375,
        -3213.533203125,
        1110.0
      ],
      [
        -3507.68994140625,
        -3122.5,
        1110.0
      ],
      [
        -3717.23486328125,
        -3131.5,
        1110.0
      ],
      [
        -3634.314208984375,
        -3131.5,
        1110.0
      ],
      [
        -3749.5,
        -3283.070068359375,
        1110.0
      ],
      [
        -3749.5,
        -3187.6650390625,
        1110.0
      ],
      [
        -3749.5,
        -3187.6650390625,
        1110.0
      ],
      [
        -3717.23486328125,
        -3131.5,
        1110.0
      ],
      [
        -3721.9990234375,
        -3335.6806640625,
        1110.0
      ],
      [
        -3749.5,
        -3283.070068359375,
        1110.0
      ],
      [
        -3596.128662109375,
        -3218.033203125,
        1110.0
      ],
      [
        -3568.378662109375,
        -3213.533203125,
        1110.0
      ],
      [
        -3682.0,
        -3273.0,
        1208.484375
      ],
      [
        -3682.0,
        -3310.72802734375,
        1175.0
      ],
      [
        -3682.0,
        -3310.72802734375,
        1175.0
      ],
      [
        -3656.84814453125,
        -3273.0,
        1175.0
      ],
      [
        -3682.0,
        -3290.0,
        1193.3966064453125
      ],
      [
        -3668.181396484375,
        -3290.0,
        1175.0
      ],
      [
        -3668.181396484375,
        -3290.0,
        1175.0
      ],
      [
        -3682.0,
        -3290.0,
        1193.3966064453125
      ],
      [
        -3682.0,
        -3288.193603515625,
        1195.0
      ],
      [
        -3671.87109375,
        -3273.0,
        1195.0
      ],
      [
        -3671.87109375,
        -3273.0,
        1195.0
      ],
      [
        -3682.0,
        -3273.0,
        1208.484375
      ],
      [
        -3678.181396484375,
        -3305.0,
        1175.0
      ],
      [
        -3682.0,
        -3305.0,
        1180.083740234375
      ],
      [
        -3682.0,
        -3305.0,
        1180.083740234375
      ],
      [
        -3678.181396484375,
        -3305.0,
        1175.0
      ],
      [
        -3529.622802734375,
        -3339.69921875,
        1110.0
      ],
      [
        -3616.132568359375,
        -3347.5634765625,
        1110.0
      ],
      [
        -3514.0,
        -3407.3125,
        1220.0
      ],
      [
        -3454.0,
        -3401.85791015625,
        1220.0
      ],
      [
        -3366.888427734375,
        -3353.146240234375,
        1155.0
      ],
      [
        -3365.630126953125,
        -3353.8759765625,
        1156.3450927734375
      ],
      [
        -3365.11572265625,
        -3352.985107421875,
        1155.0
      ],
      [
        -3366.888427734375,
        -3353.146240234375,
        1155.0
      ],
      [
        -3365.630126953125,
        -3353.8759765625,
        1156.3450927734375
      ],
      [
        -3365.11572265625,
        -3352.985107421875,
        1155.0
      ],
      [
        -3454.0,
        -3406.156982421875,
        1174.2286376953125
      ],
      [
        -3454.0,
        -3382.8740234375,
        1189.7506103515625
      ],
      [
        -3514.0,
        -3386.719482421875,
        1187.1868896484375
      ],
      [
        -3454.0,
        -3401.85791015625,
        1220.0
      ],
      [
        -3454.0,
        -3382.8740234375,
        1189.7506103515625
      ],
      [
        -3514.0,
        -3386.719482421875,
        1187.1868896484375
      ],
      [
        -3514.0,
        -3407.3125,
        1220.0
      ],
      [
        -3438.327880859375,
        -3167.835693359375,
        1110.0
      ],
      [
        -3443.71044921875,
        -3248.5732421875,
        1110.0
      ],
      [
        -3396.9326171875,
        -3345.552490234375,
        1195.0
      ],
      [
        -3395.125732421875,
        -3318.447509765625,
        1195.0
      ],
      [
        -3396.9326171875,
        -3345.552490234375,
        1195.0
      ],
      [
        -3398.3388671875,
        -3366.64111328125,
        1195.0
      ],
      [
        -3393.719970703125,
        -3297.35888671875,
        1195.0
      ],
      [
        -3395.125732421875,
        -3318.447509765625,
        1195.0
      ],
      [
        -3396.9326171875,
        -3345.552490234375,
        1195.0
      ],
      [
        -3398.3388671875,
        -3366.64111328125,
        1195.0
      ],
      [
        -3393.719970703125,
        -3297.35888671875,
        1195.0
      ],
      [
        -3395.125732421875,
        -3318.447509765625,
        1195.0
      ],
      [
        -3383.965087890625,
        -3338.955810546875,
        1215.0
      ],
      [
        -3383.116943359375,
        -3326.232177734375,
        1215.0
      ],
      [
        -3385.81103515625,
        -3366.64111328125,
        1215.0
      ],
      [
        -3384.75634765625,
        -3350.823486328125,
        1215.0
      ],
      [
        -3381.999267578125,
        -3309.467041015625,
        1215.0
      ],
      [
        -3381.19189453125,
        -3297.35888671875,
        1215.0
      ],
      [
        -3383.965087890625,
        -3338.955810546875,
        1215.0
      ],
      [
        -3384.75634765625,
        -3350.823486328125,
        1215.0
      ],
      [
        -3381.999267578125,
        -3309.467041015625,
        1215.0
      ],
      [
        -3383.116943359375,
        -3326.232177734375,
        1215.0
      ],
      [
        -3381.999267578125,
        -3309.467041015625,
        1215.0
      ],
      [
        -3388.673828125,
        -3318.447509765625,
        1205.30029296875
      ],
      [
        -3388.673828125,
        -3318.447509765625,
        1205.30029296875
      ],
      [
        -3381.999267578125,
        -3309.467041015625,
        1215.0
      ],
      [
        -3388.5,
        -3297.35888671875,
        1203.3330078125
      ],
      [
        -3389.96142578125,
        -3297.35888671875,
        1201.0
      ],
      [
        -3393.719970703125,
        -3297.35888671875,
        1195.0
      ],
      [
        -3381.19189453125,
        -3297.35888671875,
        1215.0
      ],
      [
        -3390.712890625,
        -3297.35888671875,
        1199.800048828125
      ],
      [
        -3390.859619140625,
        -3299.55908203125,
        1199.800048828125
      ],
      [
        -3386.89990234375,
        -3301.1591796875,
        1199.800048828125
      ],
      [
        -3391.435546875,
        -3317.937744140625,
        1199.800048828125
      ],
      [
        -3388.295166015625,
        -3317.937744140625,
        1195.0
      ],
      [
        -3388.295166015625,
        -3317.937744140625,
        1199.800048828125
      ],
      [
        -3388.674072265625,
        -3318.447509765625,
        1195.0
      ],
      [
        -3391.437255859375,
        -3318.447509765625,
        1199.800048828125
      ],
      [
        -3388.674072265625,
        -3318.447509765625,
        1199.800048828125
      ],
      [
        -3391.435546875,
        -3317.937744140625,
        1199.800048828125
      ],
      [
        -3391.437255859375,
        -3318.447509765625,
        1199.800048828125
      ],
      [
        -3392.165771484375,
        -3300.35888671875,
        1197.800048828125
      ],
      [
        -3393.919677734375,
        -3300.35888671875,
        1195.0
      ],
      [
        -3390.859619140625,
        -3299.55908203125,
        1199.800048828125
      ],
      [
        -3392.165771484375,
        -3300.35888671875,
        1197.800048828125
      ],
      [
        -3387.7001953125,
        -3300.35888671875,
        1199.800048828125
      ],
      [
        -3391.437255859375,
        -3318.447509765625,
        1200.8887939453125
      ],
      [
        -3388.674072265625,
        -3318.447509765625,
        1205.30029296875
      ],
      [
        -3391.435546875,
        -3317.937744140625,
        1200.837158203125
      ],
      [
        -3388.295166015625,
        -3317.937744140625,
        1205.0
      ],
      [
        -3388.827880859375,
        -3317.937744140625,
        1205.0
      ],
      [
        -3388.827880859375,
        -3317.937744140625,
        1205.0
      ],
      [
        -3388.295166015625,
        -3317.937744140625,
        1205.0
      ],
      [
        -3388.295166015625,
        -3317.937744140625,
        1205.8504638671875
      ],
      [
        -3391.435546875,
        -3317.937744140625,
        1200.837158203125
      ],
      [
        -3391.437255859375,
        -3318.447509765625,
        1200.8887939453125
      ],
      [
        -3387.44384765625,
        -3320.140625,
        1207.44384765625
      ],
      [
        -3388.66259765625,
        -3318.432373046875,
        1205.3165283203125
      ],
      [
        -3387.44384765625,
        -3320.140625,
        1207.44384765625
      ],
      [
        -3383.115234375,
        -3326.207275390625,
        1215.0
      ],
      [
        -3388.3095703125,
        -3317.957275390625,
        1205.8291015625
      ],
      [
        -3383.055908203125,
        -3325.320556640625,
        1215.0
      ],
      [
        -3388.288818359375,
        -3317.937744140625,
        1205.8604736328125
      ],
      [
        -3388.659423828125,
        -3318.447509765625,
        1205.3236083984375
      ],
      [
        -3398.3388671875,
        -3366.64111328125,
        1195.0
      ],
      [
        -3385.81103515625,
        -3366.64111328125,
        1215.0
      ],
      [
        -3384.75634765625,
        -3350.823486328125,
        1215.0
      ],
      [
        -3388.673828125,
        -3345.552490234375,
        1208.184814453125
      ],
      [
        -3388.673828125,
        -3345.552490234375,
        1208.184814453125
      ],
      [
        -3384.75634765625,
        -3350.823486328125,
        1215.0
      ],
      [
        -3388.674072265625,
        -3345.552490234375,
        1208.184814453125
      ],
      [
        -3391.437255859375,
        -3345.552490234375,
        1203.7733154296875
      ],
      [
        -3388.674072265625,
        -3345.552490234375,
        1195.0
      ],
      [
        -3390.702880859375,
        -3346.062255859375,
        1205.0
      ],
      [
        -3391.435546875,
        -3346.062255859375,
        1203.8304443359375
      ],
      [
        -3388.288818359375,
        -3346.062255859375,
        1208.853759765625
      ],
      [
        -3390.702880859375,
        -3346.062255859375,
        1205.0
      ],
      [
        -3391.437255859375,
        -3345.552490234375,
        1203.7733154296875
      ],
      [
        -3391.435546875,
        -3346.062255859375,
        1203.8304443359375
      ],
      [
        -3396.41943359375,
        -3366.0400390625,
        1198.0
      ],
      [
        -3395.47998046875,
        -3366.0400390625,
        1199.5
      ],
      [
        -3395.47998046875,
        -3366.0400390625,
        1199.5
      ],
      [
        -3395.519775390625,
        -3366.639892578125,
        1199.5
      ],
      [
        -3396.459228515625,
        -3366.639892578125,
        1198.0
      ],
      [
        -3396.41943359375,
        -3366.0400390625,
        1198.0
      ],
      [
        -3383.96728515625,
        -3338.98681640625,
        1215.0
      ],
      [
        -3387.393798828125,
        -3343.789306640625,
        1210.040771484375
      ],
      [
        -3388.66259765625,
        -3345.567626953125,
        1208.2047119140625
      ],
      [
        -3387.393798828125,
        -3343.789306640625,
        1210.040771484375
      ],
      [
        -3384.038330078125,
        -3340.056396484375,
        1215.0
      ],
      [
        -3388.3095703125,
        -3346.042724609375,
        1208.8182373046875
      ],
      [
        -3388.659423828125,
        -3345.552490234375,
        1208.2081298828125
      ],
      [
        -3682.0,
        -3335.0,
        1175.0
      ],
      [
        -3682.0,
        -3320.0,
        1175.0
      ],
      [
        -3587.0,
        -3320.0,
        1175.0
      ],
      [
        -3587.0,
        -3335.0,
        1175.0
      ],
      [
        -3444.0,
        -3320.0,
        1170.0
      ],
      [
        -3524.0,
        -3320.0,
        1170.0
      ],
      [
        -3465.484375,
        -3320.0,
        1134.14013671875
      ],
      [
        -3450.097900390625,
        -3335.0,
        1167.2449951171875
      ],
      [
        -3521.506103515625,
        -3335.0,
        1110.0
      ],
      [
        -3495.59716796875,
        -3320.0,
        1110.0
      ],
      [
        -3439.95458984375,
        -3320.0,
        1170.0
      ],
      [
        -3448.136474609375,
        -3335.0,
        1170.0
      ],
      [
        -3450.097900390625,
        -3335.0,
        1167.2449951171875
      ],
      [
        -3465.484375,
        -3320.0,
        1134.14013671875
      ],
      [
        -3524.0,
        -3329.64111328125,
        1175.0
      ],
      [
        -3444.0,
        -3329.64111328125,
        1175.0
      ],
      [
        -3444.0,
        -3329.64111328125,
        1175.0
      ],
      [
        -3444.0,
        -3320.0,
        1170.0
      ],
      [
        -3444.0,
        -3320.0,
        1175.0
      ],
      [
        -3524.0,
        -3320.0,
        1170.0
      ],
      [
        -3524.0,
        -3329.64111328125,
        1175.0
      ],
      [
        -3524.0,
        -3320.0,
        1175.0
      ],
      [
        -3682.0,
        -3335.0,
        1235.0
      ],
      [
        -3682.0,
        -3329.64111328125,
        1235.0
      ],
      [
        -3682.0,
        -3329.64111328125,
        1175.0
      ],
      [
        -3682.0,
        -3335.0,
        1175.0
      ],
      [
        -3555.0,
        -3335.0,
        1210.0
      ],
      [
        -3555.0,
        -3329.64111328125,
        1210.0
      ],
      [
        -3576.0,
        -3329.64111328125,
        1235.0
      ],
      [
        -3576.0,
        -3335.0,
        1235.0
      ],
      [
        -3477.0,
        -3332.0,
        1195.0
      ],
      [
        -3477.0,
        -3335.0,
        1195.0
      ],
      [
        -3491.0,
        -3335.0,
        1195.0
      ],
      [
        -3491.0,
        -3332.0,
        1195.0
      ],
      [
        -3405.522705078125,
        -3335.0,
        1195.0
      ],
      [
        -3396.029296875,
        -3332.0,
        1195.0
      ],
      [
        -3396.229248046875,
        -3335.0,
        1195.0
      ],
      [
        -3405.522705078125,
        -3335.0,
        1195.0
      ],
      [
        -3431.26806640625,
        -3335.0,
        1195.0
      ],
      [
        -3431.26806640625,
        -3335.0,
        1195.0
      ],
      [
        -3405.522705078125,
        -3335.0,
        1195.0
      ],
      [
        -3405.522705078125,
        -3335.0,
        1215.0
      ],
      [
        -3383.701416015625,
        -3335.0,
        1215.0
      ],
      [
        -3383.50146484375,
        -3332.0,
        1215.0
      ],
      [
        -3405.522705078125,
        -3335.0,
        1215.0
      ],
      [
        -3431.26806640625,
        -3335.0,
        1215.0
      ],
      [
        -3431.26806640625,
        -3335.0,
        1195.0
      ],
      [
        -3431.26806640625,
        -3335.0,
        1215.0
      ],
      [
        -3491.0,
        -3332.0,
        1195.0
      ],
      [
        -3491.0,
        -3335.0,
        1195.0
      ],
      [
        -3491.0,
        -3335.0,
        1210.0
      ],
      [
        -3491.0,
        -3332.0,
        1210.0
      ],
      [
        -3477.0,
        -3332.0,
        1210.0
      ],
      [
        -3477.0,
        -3335.0,
        1210.0
      ],
      [
        -3477.0,
        -3335.0,
        1195.0
      ],
      [
        -3477.0,
        -3332.0,
        1195.0
      ],
      [
        -3491.0,
        -3332.0,
        1210.0
      ],
      [
        -3491.0,
        -3335.0,
        1210.0
      ],
      [
        -3477.0,
        -3335.0,
        1210.0
      ],
      [
        -3477.0,
        -3332.0,
        1210.0
      ],
      [
        -3405.522705078125,
        -3335.0,
        1215.0
      ],
      [
        -3405.522705078125,
        -3335.0,
        1207.660400390625
      ],
      [
        -3405.522705078125,
        -3335.0,
        1195.0
      ],
      [
        -3405.522705078125,
        -3335.0,
        1207.660400390625
      ],
      [
        -3406.080078125,
        -3335.0,
        1195.0
      ],
      [
        -3406.080078125,
        -3335.0,
        1205.0
      ],
      [
        -3406.080078125,
        -3335.0,
        1215.0
      ],
      [
        -3406.080078125,
        -3335.0,
        1205.0
      ],
      [
        -3405.83837890625,
        -3329.64111328125,
        1195.0
      ],
      [
        -3395.8720703125,
        -3329.64111328125,
        1195.0
      ],
      [
        -3433.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3405.83837890625,
        -3329.64111328125,
        1195.0
      ],
      [
        -3433.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3405.83837890625,
        -3329.64111328125,
        1195.0
      ],
      [
        -3405.83837890625,
        -3329.64111328125,
        1215.0
      ],
      [
        -3383.34423828125,
        -3329.64111328125,
        1215.0
      ],
      [
        -3405.83837890625,
        -3329.64111328125,
        1215.0
      ],
      [
        -3433.0,
        -3329.64111328125,
        1215.0
      ],
      [
        -3433.0,
        -3329.64111328125,
        1215.0
      ],
      [
        -3433.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3405.901611328125,
        -3329.64111328125,
        1208.5010986328125
      ],
      [
        -3405.90185546875,
        -3329.64111328125,
        1215.0
      ],
      [
        -3405.901611328125,
        -3329.64111328125,
        1208.5010986328125
      ],
      [
        -3405.901611328125,
        -3329.64111328125,
        1195.0
      ],
      [
        -3406.47607421875,
        -3329.64111328125,
        1205.0
      ],
      [
        -3406.47607421875,
        -3329.64111328125,
        1195.0
      ],
      [
        -3406.476318359375,
        -3329.64111328125,
        1215.0
      ],
      [
        -3406.47607421875,
        -3329.64111328125,
        1205.0
      ],
      [
        -3576.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3585.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3682.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3669.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3587.0,
        -3335.0,
        1195.0
      ],
      [
        -3587.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3555.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3555.0,
        -3335.0,
        1195.0
      ],
      [
        -3587.0,
        -3335.0,
        1175.0
      ],
      [
        -3587.0,
        -3329.64111328125,
        1175.0
      ],
      [
        -3587.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3587.0,
        -3335.0,
        1195.0
      ],
      [
        -3669.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3669.0,
        -3329.64111328125,
        1194.0
      ],
      [
        -3585.0,
        -3329.64111328125,
        1198.5
      ],
      [
        -3585.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3585.0,
        -3335.0,
        1235.0
      ],
      [
        -3585.0,
        -3329.64111328125,
        1235.0
      ],
      [
        -3585.0,
        -3329.64111328125,
        1211.5
      ],
      [
        -3585.0,
        -3335.0,
        1211.5
      ],
      [
        -3587.0,
        -3335.0,
        1198.5
      ],
      [
        -3587.0,
        -3335.0,
        1211.5
      ],
      [
        -3587.0,
        -3335.0,
        1195.0
      ],
      [
        -3587.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3587.0,
        -3329.64111328125,
        1198.5
      ],
      [
        -3587.0,
        -3335.0,
        1198.5
      ],
      [
        -3587.0,
        -3335.0,
        1211.5
      ],
      [
        -3587.0,
        -3329.64111328125,
        1211.5
      ],
      [
        -3587.0,
        -3329.64111328125,
        1235.0
      ],
      [
        -3587.0,
        -3335.0,
        1235.0
      ],
      [
        -3585.0,
        -3329.64111328125,
        1211.5
      ],
      [
        -3587.0,
        -3329.64111328125,
        1211.5
      ],
      [
        -3587.0,
        -3329.64111328125,
        1198.5
      ],
      [
        -3585.0,
        -3329.64111328125,
        1198.5
      ],
      [
        -3576.0,
        -3335.0,
        1211.5
      ],
      [
        -3576.0,
        -3335.0,
        1195.0
      ],
      [
        -3585.0,
        -3335.0,
        1211.5
      ],
      [
        -3576.0,
        -3335.0,
        1211.5
      ],
      [
        -3555.0,
        -3335.0,
        1195.0
      ],
      [
        -3555.0,
        -3333.0,
        1195.0
      ],
      [
        -3555.0,
        -3333.0,
        1210.0
      ],
      [
        -3555.0,
        -3335.0,
        1210.0
      ],
      [
        -3555.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3555.0,
        -3329.64111328125,
        1210.0
      ],
      [
        -3401.090576171875,
        -3320.0,
        1195.0
      ],
      [
        -3395.229248046875,
        -3320.0,
        1195.0
      ],
      [
        -3444.0,
        -3320.0,
        1195.0
      ],
      [
        -3467.279052734375,
        -3320.0,
        1195.0
      ],
      [
        -3500.720947265625,
        -3320.0,
        1195.0
      ],
      [
        -3524.0,
        -3320.0,
        1195.0
      ],
      [
        -3401.090576171875,
        -3320.0,
        1195.0
      ],
      [
        -3401.090576171875,
        -3320.0,
        1195.0
      ],
      [
        -3467.279052734375,
        -3320.0,
        1195.0
      ],
      [
        -3500.720947265625,
        -3320.0,
        1195.0
      ],
      [
        -3587.0,
        -3320.0,
        1195.0
      ],
      [
        -3555.0,
        -3320.0,
        1195.0
      ],
      [
        -3444.0,
        -3320.0,
        1192.0
      ],
      [
        -3467.279052734375,
        -3320.0,
        1192.0
      ],
      [
        -3524.0,
        -3320.0,
        1192.0
      ],
      [
        -3500.720947265625,
        -3320.0,
        1192.0
      ],
      [
        -3467.279052734375,
        -3320.0,
        1192.0
      ],
      [
        -3500.720947265625,
        -3320.0,
        1192.0
      ],
      [
        -3587.0,
        -3320.0,
        1192.0
      ],
      [
        -3587.0,
        -3320.0,
        1195.0
      ],
      [
        -3587.0,
        -3329.64111328125,
        1192.0
      ],
      [
        -3524.0,
        -3320.0,
        1192.0
      ],
      [
        -3524.0,
        -3321.92822265625,
        1192.0
      ],
      [
        -3524.0,
        -3321.92822265625,
        1192.0
      ],
      [
        -3524.0,
        -3329.64111328125,
        1192.0
      ],
      [
        -3524.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3444.0,
        -3320.0,
        1192.0
      ],
      [
        -3444.0,
        -3321.92822265625,
        1192.0
      ],
      [
        -3444.0,
        -3321.92822265625,
        1192.0
      ],
      [
        -3444.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3444.0,
        -3329.64111328125,
        1192.0
      ],
      [
        -3682.0,
        -3320.0,
        1195.0
      ],
      [
        -3682.0,
        -3320.0,
        1192.0
      ],
      [
        -3682.0,
        -3329.64111328125,
        1192.0
      ],
      [
        -3682.0,
        -3329.64111328125,
        1195.0
      ],
      [
        -3587.0,
        -3320.0,
        1175.0
      ],
      [
        -3444.0,
        -3320.0,
        1180.0
      ],
      [
        -3444.0,
        -3320.0,
        1180.0
      ],
      [
        -3524.0,
        -3320.0,
        1180.0
      ],
      [
        -3524.0,
        -3320.0,
        1180.0
      ],
      [
        -3682.0,
        -3320.0,
        1175.0
      ],
      [
        -3682.0,
        -3320.0,
        1235.0
      ],
      [
        -3444.0,
        -3320.0,
        1235.0
      ],
      [
        -3401.090576171875,
        -3320.0,
        1215.0
      ],
      [
        -3387.565673828125,
        -3320.0,
        1215.0
      ],
      [
        -3401.090576171875,
        -3320.0,
        1215.0
      ],
      [
        -3387.565673828125,
        -3320.0,
        1215.0
      ],
      [
        -3382.701416015625,
        -3320.0,
        1215.0
      ],
      [
        -3401.09375,
        -3320.0,
        1195.0
      ],
      [
        -3401.09375,
        -3320.0,
        1210.879150390625
      ],
      [
        -3401.09375,
        -3320.0,
        1215.0
      ],
      [
        -3401.09375,
        -3320.0,
        1210.879150390625
      ],
      [
        -3401.66796875,
        -3320.0,
        1195.0
      ],
      [
        -3401.66796875,
        -3320.0,
        1205.0
      ],
      [
        -3401.668212890625,
        -3320.0,
        1215.0
      ],
      [
        -3401.66796875,
        -3320.0,
        1205.0
      ],
      [
        -3387.544189453125,
        -3320.0,
        1208.0447998046875
      ],
      [
        -3387.544189453125,
        -3320.0,
        1207.2686767578125
      ],
      [
        -3387.544189453125,
        -3320.0,
        1208.0447998046875
      ],
      [
        -3387.544189453125,
        -3320.0,
        1215.0
      ],
      [
        -3386.85205078125,
        -3320.0,
        1208.373291015625
      ],
      [
        -3386.85205078125,
        -3320.0,
        1215.0
      ],
      [
        -3524.0,
        -3320.0,
        1235.0
      ],
      [
        -3555.0,
        -3320.0,
        1210.0
      ],
      [
        -3576.0,
        -3320.0,
        1235.0
      ],
      [
        -3585.0,
        -3320.0,
        1235.0
      ],
      [
        -3585.0,
        -3320.0,
        1211.5
      ],
      [
        -3587.0,
        -3320.0,
        1198.5
      ],
      [
        -3587.0,
        -3320.0,
        1211.5
      ],
      [
        -3587.0,
        -3320.0,
        1195.0
      ],
      [
        -3587.0,
        -3320.0,
        1198.5
      ],
      [
        -3587.0,
        -3320.0,
        1211.5
      ],
      [
        -3587.0,
        -3320.0,
        1235.0
      ],
      [
        -3576.0,
        -3320.0,
        1211.5
      ],
      [
        -3576.0,
        -3320.0,
        1195.0
      ],
      [
        -3585.0,
        -3320.0,
        1211.5
      ],
      [
        -3576.0,
        -3320.0,
        1211.5
      ],
      [
        -3454.0,
        -3353.0,
        1220.0
      ],
      [
        -3514.0,
        -3353.0,
        1220.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1195.0
      ],
      [
        -3420.875732421875,
        -3353.0,
        1195.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1195.0
      ],
      [
        -3397.42919921875,
        -3353.0,
        1195.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1195.0
      ],
      [
        -3397.42919921875,
        -3353.0,
        1195.0
      ],
      [
        -3420.875732421875,
        -3353.0,
        1195.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1195.0
      ],
      [
        -3454.0,
        -3353.0,
        1195.0
      ],
      [
        -3514.0,
        -3353.0,
        1195.0
      ],
      [
        -3477.752197265625,
        -3353.0,
        1170.0
      ],
      [
        -3525.3955078125,
        -3353.0,
        1131.8062744140625
      ],
      [
        -3514.0,
        -3386.502197265625,
        1187.331787109375
      ],
      [
        -3484.567138671875,
        -3375.0,
        1195.0
      ],
      [
        -3454.0,
        -3386.16845703125,
        1195.0
      ],
      [
        -3514.0,
        -3386.502197265625,
        1187.331787109375
      ],
      [
        -3514.0,
        -3388.8544921875,
        1190.5888671875
      ],
      [
        -3514.0,
        -3391.622802734375,
        1195.0
      ],
      [
        -3514.0,
        -3353.0,
        1195.0
      ],
      [
        -3514.0,
        -3353.0,
        1220.0
      ],
      [
        -3454.0,
        -3353.0,
        1220.0
      ],
      [
        -3454.0,
        -3353.0,
        1195.0
      ],
      [
        -3384.9013671875,
        -3353.0,
        1215.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1215.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1215.0
      ],
      [
        -3420.875732421875,
        -3353.0,
        1215.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1215.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1195.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1195.0
      ],
      [
        -3404.802001953125,
        -3353.0,
        1215.0
      ],
      [
        -3420.875732421875,
        -3353.0,
        1195.0
      ],
      [
        -3420.875732421875,
        -3353.0,
        1215.0
      ],
      [
        -3529.622802734375,
        -3339.69921875,
        1110.0
      ],
      [
        -3682.0,
        -3353.0,
        1195.0
      ],
      [
        -3682.0,
        -3335.0,
        1195.0
      ],
      [
        -3563.39990234375,
        -3353.0,
        1220.0
      ],
      [
        -3563.39990234375,
        -3335.0,
        1220.0
      ],
      [
        -3585.0,
        -3335.0,
        1220.0
      ],
      [
        -3585.0,
        -3353.0,
        1220.0
      ],
      [
        -3682.0,
        -3353.0,
        1220.0
      ],
      [
        -3682.0,
        -3335.0,
        1220.0
      ],
      [
        -3587.0,
        -3349.80859375,
        1220.0
      ],
      [
        -3587.0,
        -3353.0,
        1220.0
      ],
      [
        -3587.0,
        -3335.0,
        1220.0
      ],
      [
        -3587.0,
        -3349.80859375,
        1220.0
      ],
      [
        -3682.0,
        -3350.0,
        1220.0
      ],
      [
        -3682.0,
        -3350.0,
        1195.0
      ],
      [
        -3422.60791015625,
        -3350.0,
        1195.0
      ],
      [
        -3422.60791015625,
        -3350.0,
        1215.0
      ],
      [
        -3555.0,
        -3350.0,
        1195.0
      ],
      [
        -3555.0,
        -3350.0,
        1210.0
      ],
      [
        -3587.0,
        -3350.0,
        1197.0999755859375
      ],
      [
        -3587.0,
        -3350.0,
        1220.0
      ],
      [
        -3587.0,
        -3350.0,
        1195.0
      ],
      [
        -3587.0,
        -3350.0,
        1197.0999755859375
      ],
      [
        -3555.0,
        -3350.0,
        1210.0
      ],
      [
        -3563.39990234375,
        -3350.0,
        1220.0
      ],
      [
        -3585.0,
        -3337.0,
        1220.0
      ],
      [
        -3585.0,
        -3350.0,
        1198.5
      ],
      [
        -3585.0,
        -3350.0,
        1211.5
      ],
      [
        -3585.0,
        -3350.0,
        1195.0
      ],
      [
        -3585.0,
        -3350.0,
        1198.5
      ],
      [
        -3585.0,
        -3350.0,
        1211.5
      ],
      [
        -3585.0,
        -3350.0,
        1220.0
      ],
      [
        -3620.0,
        -3350.0,
        1205.25
      ],
      [
        -3620.0,
        -3350.0,
        1195.0
      ],
      [
        -3626.0,
        -3350.0,
        1205.25
      ],
      [
        -3620.0,
        -3350.0,
        1205.25
      ],
      [
        -3385.368408203125,
        -3350.0,
        1215.0
      ],
      [
        -3402.9990234375,
        -3350.0,
        1215.0
      ],
      [
        -3402.9990234375,
        -3350.0,
        1215.0
      ],
      [
        -3422.60791015625,
        -3350.0,
        1215.0
      ],
      [
        -3385.368408203125,
        -3350.0,
        1215.0
      ],
      [
        -3384.701416015625,
        -3350.0,
        1215.0
      ],
      [
        -3402.9990234375,
        -3350.0,
        1215.0
      ],
      [
        -3402.9990234375,
        -3350.0,
        1195.0
      ],
      [
        -3402.9990234375,
        -3350.0,
        1195.0
      ],
      [
        -3402.9990234375,
        -3350.0,
        1215.0
      ],
      [
        -3400.325927734375,
        -3345.552490234375,
        1210.4283447265625
      ],
      [
        -3400.325927734375,
        -3345.552490234375,
        1215.0
      ],
      [
        -3400.325927734375,
        -3345.552490234375,
        1195.0
      ],
      [
        -3400.325927734375,
        -3345.552490234375,
        1210.4283447265625
      ],
      [
        -3400.63232421875,
        -3346.062255859375,
        1195.0
      ],
      [
        -3400.63232421875,
        -3346.062255859375,
        1205.0
      ],
      [
        -3400.63232421875,
        -3346.062255859375,
        1215.0
      ],
      [
        -3400.63232421875,
        -3346.062255859375,
        1205.0
      ],
      [
        -3397.85302734375,
        -3345.552490234375,
        1215.0
      ],
      [
        -3388.294921875,
        -3346.062255859375,
        1215.0
      ],
      [
        -3388.294921875,
        -3346.062255859375,
        1208.8438720703125
      ],
      [
        -3388.294921875,
        -3346.062255859375,
        1215.0
      ],
      [
        -3388.294921875,
        -3346.062255859375,
        1208.8438720703125
      ],
      [
        -3388.65185546875,
        -3345.552490234375,
        1215.0
      ],
      [
        -3388.65185546875,
        -3345.552490234375,
        1214.7034912109375
      ],
      [
        -3388.65185546875,
        -3345.552490234375,
        1208.2203369140625
      ],
      [
        -3388.65185546875,
        -3345.552490234375,
        1214.7034912109375
      ],
      [
        -3387.959716796875,
        -3345.552490234375,
        1215.0
      ],
      [
        -3387.959716796875,
        -3345.552490234375,
        1209.324462890625
      ],
      [
        -3385.368408203125,
        -3350.0,
        1215.0
      ],
      [
        -3385.368408203125,
        -3350.0,
        1213.935302734375
      ],
      [
        -3385.368408203125,
        -3350.0,
        1215.0
      ],
      [
        -3385.368408203125,
        -3350.0,
        1213.935302734375
      ],
      [
        -3507.68994140625,
        -3122.5,
        1110.0
      ],
      [
        -3457.757568359375,
        -3122.5,
        1110.0
      ],
      [
        -3524.0,
        -3305.0,
        1180.0
      ],
      [
        -3524.0,
        -3305.0,
        1235.0
      ],
      [
        -3524.0,
        -3305.0,
        1170.0
      ],
      [
        -3524.0,
        -3305.0,
        1180.0
      ],
      [
        -3587.0,
        -3290.0,
        1195.0
      ],
      [
        -3555.0,
        -3290.0,
        1195.0
      ],
      [
        -3668.181396484375,
        -3290.0,
        1175.0
      ],
      [
        -3587.0,
        -3290.0,
        1175.0
      ],
      [
        -3587.0,
        -3290.0,
        1175.0
      ],
      [
        -3587.0,
        -3290.0,
        1195.0
      ],
      [
        -3682.0,
        -3288.193359375,
        1195.0
      ],
      [
        -3682.0,
        -3290.0,
        1193.396484375
      ],
      [
        -3682.0,
        -3290.0,
        1195.0
      ],
      [
        -3682.0,
        -3290.0,
        1235.0
      ],
      [
        -3555.0,
        -3290.0,
        1210.0
      ],
      [
        -3576.0,
        -3290.0,
        1235.0
      ],
      [
        -3587.0,
        -3290.0,
        1198.5
      ],
      [
        -3587.0,
        -3290.0,
        1211.5
      ],
      [
        -3587.0,
        -3290.0,
        1195.0
      ],
      [
        -3587.0,
        -3290.0,
        1198.5
      ],
      [
        -3587.0,
        -3290.0,
        1211.5
      ],
      [
        -3587.0,
        -3290.0,
        1235.0
      ],
      [
        -3585.0,
        -3290.0,
        1235.0
      ],
      [
        -3585.0,
        -3290.0,
        1211.5
      ],
      [
        -3555.0,
        -3290.0,
        1210.0
      ],
      [
        -3555.0,
        -3290.0,
        1195.0
      ],
      [
        -3576.0,
        -3290.0,
        1211.5
      ],
      [
        -3576.0,
        -3290.0,
        1195.0
      ],
      [
        -3585.0,
        -3290.0,
        1211.5
      ],
      [
        -3576.0,
        -3290.0,
        1211.5
      ],
      [
        -3678.181396484375,
        -3305.0,
        1175.0
      ],
      [
        -3587.0,
        -3305.0,
        1175.0
      ],
      [
        -3682.0,
        -3305.0,
        1235.0
      ],
      [
        -3682.0,
        -3305.0,
        1180.083740234375
      ],
      [
        -3555.0,
        -3305.0,
        1210.0
      ],
      [
        -3576.0,
        -3305.0,
        1235.0
      ],
      [
        -3587.0,
        -3305.0,
        1195.0
      ],
      [
        -3555.0,
        -3305.0,
        1195.0
      ],
      [
        -3587.0,
        -3305.0,
        1175.0
      ],
      [
        -3587.0,
        -3305.0,
        1195.0
      ],
      [
        -3585.0,
        -3305.0,
        1235.0
      ],
      [
        -3585.0,
        -3305.0,
        1211.5
      ],
      [
        -3587.0,
        -3305.0,
        1198.5
      ],
      [
        -3587.0,
        -3305.0,
        1211.5
      ],
      [
        -3587.0,
        -3305.0,
        1195.0
      ],
      [
        -3587.0,
        -3305.0,
        1198.5
      ],
      [
        -3587.0,
        -3305.0,
        1211.5
      ],
      [
        -3587.0,
        -3305.0,
        1235.0
      ],
      [
        -3576.0,
        -3305.0,
        1211.5
      ],
      [
        -3576.0,
        -3305.0,
        1195.0
      ],
      [
        -3585.0,
        -3305.0,
        1211.5
      ],
      [
        -3576.0,
        -3305.0,
        1211.5
      ],
      [
        -3444.0,
        -3305.0,
        1180.0
      ],
      [
        -3444.0,
        -3305.0,
        1235.0
      ],
      [
        -3444.0,
        -3305.0,
        1180.0
      ],
      [
        -3444.0,
        -3305.0,
        1170.0
      ],
      [
        -3444.0,
        -3101.635986328125,
        1143.38232421875
      ],
      [
        -3438.327880859375,
        -3167.835693359375,
        1110.0
      ],
      [
        -3444.0,
        -3154.600830078125,
        1110.0
      ],
      [
        -3443.71044921875,
        -3248.5732421875,
        1110.0
      ],
      [
        -3431.772705078125,
        -3305.0,
        1170.0
      ],
      [
        -3444.0,
        -3305.0,
        1152.8251953125
      ],
      [
        -3444.0,
        -3249.10400390625,
        1110.0
      ],
      [
        -3409.806884765625,
        -3297.35888671875,
        1195.0
      ],
      [
        -3395.568115234375,
        -3297.35888671875,
        1215.0
      ],
      [
        -3381.701416015625,
        -3305.0,
        1215.0
      ],
      [
        -3395.568115234375,
        -3297.35888671875,
        1215.0
      ],
      [
        -3399.736083984375,
        -3305.0,
        1215.0
      ],
      [
        -3411.326171875,
        -3300.144287109375,
        1195.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1195.0
      ],
      [
        -3413.974853515625,
        -3305.0,
        1195.0
      ],
      [
        -3411.326171875,
        -3300.144287109375,
        1195.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1195.0
      ],
      [
        -3413.974853515625,
        -3305.0,
        1195.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1195.0
      ],
      [
        -3411.326171875,
        -3300.144287109375,
        1195.0
      ],
      [
        -3409.806884765625,
        -3297.35888671875,
        1195.0
      ],
      [
        -3394.229248046875,
        -3305.0,
        1195.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1195.0
      ],
      [
        -3411.326171875,
        -3300.144287109375,
        1195.0
      ],
      [
        -3409.806884765625,
        -3297.35888671875,
        1195.0
      ],
      [
        -3394.229248046875,
        -3305.0,
        1195.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1202.8193359375
      ],
      [
        -3408.407958984375,
        -3305.0,
        1195.0
      ],
      [
        -3411.326171875,
        -3300.144287109375,
        1195.0
      ],
      [
        -3411.326171875,
        -3300.144287109375,
        1195.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1195.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1202.8193359375
      ],
      [
        -3407.6083984375,
        -3299.59326171875,
        1199.800048828125
      ],
      [
        -3406.3896484375,
        -3297.35888671875,
        1199.800048828125
      ],
      [
        -3401.89990234375,
        -3305.0,
        1199.800048828125
      ],
      [
        -3408.40771484375,
        -3305.0,
        1199.800048828125
      ],
      [
        -3409.53466796875,
        -3303.124755859375,
        1199.800048828125
      ],
      [
        -3407.6083984375,
        -3299.59326171875,
        1199.800048828125
      ],
      [
        -3400.6201171875,
        -3301.47900390625,
        1195.0
      ],
      [
        -3401.10009765625,
        -3305.0,
        1195.0
      ],
      [
        -3401.10009765625,
        -3305.0,
        1197.800048828125
      ],
      [
        -3401.10009765625,
        -3305.0,
        1197.800048828125
      ],
      [
        -3401.89990234375,
        -3305.0,
        1199.800048828125
      ],
      [
        -3401.10009765625,
        -3301.1591796875,
        1199.800048828125
      ],
      [
        -3408.407958984375,
        -3305.0,
        1215.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1215.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1215.0
      ],
      [
        -3408.407958984375,
        -3305.0,
        1215.0
      ],
      [
        -3444.0,
        -3305.0,
        1170.0
      ],
      [
        -3524.0,
        -3305.0,
        1170.0
      ],
      [
        -3474.48876953125,
        -3305.0,
        1110.0
      ],
      [
        -3457.757568359375,
        -3122.5,
        1110.0
      ],
      [
        -3489.0,
        -3275.0,
        1180.0
      ],
      [
        -3479.0,
        -3275.0,
        1180.0
      ],
      [
        -3489.0,
        -3265.0,
        1180.0
      ],
      [
        -3489.0,
        -3275.0,
        1180.0
      ],
      [
        -3489.0,
        -3265.0,
        1180.0
      ],
      [
        -3479.0,
        -3265.0,
        1180.0
      ],
      [
        -3479.0,
        -3275.0,
        1180.0
      ],
      [
        -3479.0,
        -3265.0,
        1180.0
      ],
      [
        -3489.0,
        -3300.0,
        1180.0
      ],
      [
        -3479.0,
        -3300.0,
        1180.0
      ],
      [
        -3489.0,
        -3305.0,
        1170.0
      ],
      [
        -3489.0,
        -3300.0,
        1180.0
      ],
      [
        -3489.0,
        -3305.0,
        1180.0
      ],
      [
        -3479.0,
        -3300.0,
        1180.0
      ],
      [
        -3479.0,
        -3305.0,
        1170.0
      ],
      [
        -3479.0,
        -3305.0,
        1180.0
      ],
      [
        -3474.39990234375,
        -3205.0,
        1215.0
      ],
      [
        -3493.60009765625,
        -3205.0,
        1215.0
      ],
      [
        -3444.0,
        -3205.0,
        1215.0
      ],
      [
        -3474.39990234375,
        -3205.0,
        1215.0
      ],
      [
        -3524.0,
        -3205.0,
        1215.0
      ],
      [
        -3493.60009765625,
        -3205.0,
        1215.0
      ],
      [
        -3489.96142578125,
        -3213.35888671875,
        1195.0
      ],
      [
        -3489.96142578125,
        -3205.0,
        1195.0
      ],
      [
        -3478.038330078125,
        -3213.35888671875,
        1195.0
      ],
      [
        -3478.038330078125,
        -3205.0,
        1195.0
      ],
      [
        -3489.0,
        -3305.0,
        1195.0
      ],
      [
        -3479.0,
        -3305.0,
        1195.0
      ],
      [
        -3489.0,
        -3305.0,
        1195.0
      ],
      [
        -3479.0,
        -3305.0,
        1195.0
      ],
      [
        -3476.704345703125,
        -3309.06201171875,
        1110.0
      ],
      [
        -3476.704345703125,
        -3309.06201171875,
        1110.0
      ],
      [
        -3444.0,
        -3320.0,
        1175.0
      ],
      [
        -3444.0,
        -3305.0,
        1175.0
      ],
      [
        -3524.0,
        -3320.0,
        1175.0
      ],
      [
        -3524.0,
        -3305.0,
        1175.0
      ],
      [
        -3489.0,
        -3310.0,
        1175.0
      ],
      [
        -3479.0,
        -3310.0,
        1175.0
      ],
      [
        -3489.0,
        -3305.0,
        1175.0
      ],
      [
        -3489.0,
        -3310.0,
        1175.0
      ],
      [
        -3479.0,
        -3310.0,
        1175.0
      ],
      [
        -3479.0,
        -3305.0,
        1175.0
      ],
      [
        -3524.0,
        -3318.755126953125,
        1195.0
      ],
      [
        -3524.0,
        -3318.755126953125,
        1192.0
      ],
      [
        -3524.0,
        -3320.0,
        1192.0
      ],
      [
        -3587.0,
        -3318.755126953125,
        1195.0
      ],
      [
        -3587.0,
        -3320.0,
        1192.0
      ],
      [
        -3587.0,
        -3318.755126953125,
        1192.0
      ],
      [
        -3444.0,
        -3318.755126953125,
        1195.0
      ],
      [
        -3444.0,
        -3320.0,
        1192.0
      ],
      [
        -3444.0,
        -3318.755126953125,
        1192.0
      ],
      [
        -3587.0,
        -3305.0,
        1192.0
      ],
      [
        -3524.0,
        -3305.0,
        1192.0
      ],
      [
        -3444.0,
        -3305.0,
        1192.0
      ],
      [
        -3489.0,
        -3310.0,
        1192.0
      ],
      [
        -3479.0,
        -3310.0,
        1192.0
      ],
      [
        -3489.0,
        -3305.0,
        1192.0
      ],
      [
        -3489.0,
        -3310.0,
        1192.0
      ],
      [
        -3479.0,
        -3310.0,
        1192.0
      ],
      [
        -3479.0,
        -3305.0,
        1192.0
      ],
      [
        -3524.0,
        -3320.0,
        1215.0
      ],
      [
        -3524.0,
        -3305.0,
        1215.0
      ],
      [
        -3444.0,
        -3320.0,
        1215.0
      ],
      [
        -3444.0,
        -3305.0,
        1215.0
      ],
      [
        -3400.322509765625,
        -3318.453125,
        1195.0
      ],
      [
        -3400.322509765625,
        -3318.453125,
        1214.5914306640625
      ],
      [
        -3400.322509765625,
        -3318.453125,
        1215.0
      ],
      [
        -3400.322509765625,
        -3318.453125,
        1214.5914306640625
      ],
      [
        -3400.32568359375,
        -3318.447509765625,
        1215.0
      ],
      [
        -3400.3193359375,
        -3318.447509765625,
        1215.0
      ],
      [
        -3400.3193359375,
        -3318.447509765625,
        1210.413818359375
      ],
      [
        -3400.32568359375,
        -3318.447509765625,
        1210.4276123046875
      ],
      [
        -3400.32568359375,
        -3318.447509765625,
        1210.4276123046875
      ],
      [
        -3400.3193359375,
        -3318.447509765625,
        1210.413818359375
      ],
      [
        -3400.3193359375,
        -3318.447509765625,
        1195.0
      ],
      [
        -3400.32568359375,
        -3318.447509765625,
        1195.0
      ],
      [
        -3400.065185546875,
        -3317.937744140625,
        1205.0
      ],
      [
        -3400.63232421875,
        -3317.937744140625,
        1205.0
      ],
      [
        -3400.63232421875,
        -3317.937744140625,
        1195.0
      ],
      [
        -3400.065185546875,
        -3317.937744140625,
        1195.0
      ],
      [
        -3400.63232421875,
        -3317.937744140625,
        1205.0
      ],
      [
        -3400.065185546875,
        -3317.937744140625,
        1205.0
      ],
      [
        -3400.065185546875,
        -3317.937744140625,
        1215.0
      ],
      [
        -3400.63232421875,
        -3317.937744140625,
        1215.0
      ],
      [
        -3388.674072265625,
        -3318.447509765625,
        1215.0
      ],
      [
        -3388.674072265625,
        -3318.447509765625,
        1211.6829833984375
      ],
      [
        -3388.674072265625,
        -3318.447509765625,
        1211.6829833984375
      ],
      [
        -3388.674072265625,
        -3318.447509765625,
        1205.30029296875
      ],
      [
        -3388.295166015625,
        -3317.937744140625,
        1205.8504638671875
      ],
      [
        -3388.295166015625,
        -3317.937744140625,
        1215.0
      ],
      [
        -3401.66796875,
        -3320.0,
        1210.0
      ],
      [
        -3400.6396484375,
        -3317.937744140625,
        1210.0
      ],
      [
        -3400.6396484375,
        -3317.937744140625,
        1210.0
      ],
      [
        -3400.63232421875,
        -3317.937744140625,
        1210.0
      ],
      [
        -3401.09375,
        -3320.0,
        1210.0
      ],
      [
        -3400.322509765625,
        -3318.453125,
        1210.0
      ],
      [
        -3400.32568359375,
        -3318.447509765625,
        1210.0
      ],
      [
        -3400.364501953125,
        -3318.447509765625,
        1210.0
      ],
      [
        -3400.893798828125,
        -3318.447509765625,
        1195.0
      ],
      [
        -3400.893798828125,
        -3318.447509765625,
        1205.0
      ],
      [
        -3400.893798828125,
        -3318.447509765625,
        1205.0
      ],
      [
        -3400.893798828125,
        -3318.447509765625,
        1210.0
      ],
      [
        -3925.00048828125,
        -3072.300048828125,
        1059.800048828125
      ],
      [
        -3600.33203125,
        -3283.997314453125,
        1059.800048828125
      ],
      [
        -3600.33203125,
        -3283.997314453125,
        1057.0
      ],
      [
        -3718.124755859375,
        -3316.109130859375,
        1059.800048828125
      ],
      [
        -3633.056884765625,
        -3333.08544921875,
        1059.800048828125
      ],
      [
        -3633.056884765625,
        -3333.08544921875,
        1090.0
      ],
      [
        -3654.8359375,
        -3343.21923828125,
        1110.0
      ],
      [
        -3633.056884765625,
        -3333.08544921875,
        1090.0
      ],
      [
        -3728.98388671875,
        -3322.318115234375,
        1110.0
      ],
      [
        -3714.0,
        -3324.0,
        1075.0
      ],
      [
        -3727.624755859375,
        -3297.93505859375,
        1075.0
      ],
      [
        -3706.591064453125,
        -3275.2685546875,
        1075.0
      ],
      [
        -3709.409423828125,
        -3275.2685546875,
        1075.0
      ],
      [
        -3708.000244140625,
        -3276.677490234375,
        1075.0
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1075.0
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1059.800048828125
      ],
      [
        -3708.000244140625,
        -3273.859619140625,
        1075.0
      ],
      [
        -3706.591064453125,
        -3275.2685546875,
        1075.1141357421875
      ],
      [
        -3709.409423828125,
        -3275.2685546875,
        1076.523193359375
      ],
      [
        -3708.000244140625,
        -3276.677490234375,
        1075.1142578125
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1075.8187255859375
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1075.0
      ],
      [
        -3708.000244140625,
        -3273.859619140625,
        1076.523193359375
      ],
      [
        -3708.000244140625,
        -3276.677490234375,
        1076.5234375
      ],
      [
        -3708.000244140625,
        -3275.268310546875,
        1075.81884765625
      ],
      [
        -3706.591064453125,
        -3275.2685546875,
        1076.5235595703125
      ],
      [
        -3708.00048828125,
        -3275.2685546875,
        1075.81884765625
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1081.84033203125
      ],
      [
        -3640.858642578125,
        -3344.7880859375,
        1110.0
      ],
      [
        -3492.66650390625,
        -3122.5,
        1110.0
      ],
      [
        -3503.90478515625,
        -3324.809814453125,
        1110.0
      ],
      [
        -3635.51611328125,
        -3336.7744140625,
        1096.3045654296875
      ],
      [
        -3477.55078125,
        -3284.510009765625,
        1059.800048828125
      ],
      [
        -3466.0,
        -3135.0,
        1062.3284912109375
      ],
      [
        -3467.583740234375,
        -3135.0,
        1059.800048828125
      ],
      [
        -3466.0,
        -3135.0,
        1062.3284912109375
      ],
      [
        -3517.423828125,
        -3318.192626953125,
        1059.800048828125
      ],
      [
        -3616.0,
        -3335.0,
        1080.0
      ],
      [
        -3633.056884765625,
        -3333.08544921875,
        1080.0
      ],
      [
        -3501.0,
        -3135.0,
        1070.0
      ],
      [
        -3466.0,
        -3135.0,
        1070.0
      ],
      [
        -3466.0,
        -3135.0,
        1070.0
      ],
      [
        -3463.575439453125,
        -3140.657470703125,
        1070.0
      ],
      [
        -3463.575439453125,
        -3140.657470703125,
        1066.8013916015625
      ],
      [
        -3463.575439453125,
        -3140.657470703125,
        1080.948486328125
      ],
      [
        -3456.5947265625,
        -3125.21337890625,
        1110.0
      ],
      [
        -3463.575439453125,
        -3140.657470703125,
        1090.0
      ],
      [
        -3463.575439453125,
        -3140.657470703125,
        1090.0
      ],
      [
        -3508.000244140625,
        -3288.2685546875,
        1081.84033203125
      ],
      [
        -3508.000244140625,
        -3288.2685546875,
        1059.800048828125
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -4115.0,
        -3645.0,
        1039.786865234375
      ],
      "bbox_max": [
        -3175.0,
        -2775.0,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3787.0,
        -3635.0,
        1110.0
      ],
      "bbox_max": [
        -3353.0,
        -3085.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        -3514.0,
        -3635.0,
        1115.0
      ],
      "bbox_max": [
        -3454.0,
        -3401.411865234375,
        1220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        -3514.0,
        -3635.0,
        1115.0
      ],
      "bbox_max": [
        -3454.0,
        -3401.411865234375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1185.0,
      "bbox_min": [
        -3514.0,
        -3635.0,
        1115.0
      ],
      "bbox_max": [
        -3454.0,
        -3401.411865234375,
        1220.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3514.0,
        -3600.0,
        1115.0
      ],
      "bbox_max": [
        -3454.0,
        -3401.411865234375,
        1185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 1010.9413452148438,
      "bbox_min": [
        -3514.0,
        -3600.0,
        1175.0
      ],
      "bbox_max": [
        -3454.0,
        -3585.0,
        1185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3600.0,
        1175.0
      ],
      "bbox_max": [
        -3454.0,
        -3585.0,
        1185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1135.0,
      "bbox_min": [
        -3514.0,
        -3585.0,
        1115.0
      ],
      "bbox_max": [
        -3454.0,
        -3401.411865234375,
        1185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3545.0,
      "bbox_min": [
        -3514.0,
        -3545.0,
        1115.0
      ],
      "bbox_max": [
        -3454.0,
        -3445.0,
        1135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3445.0,
      "bbox_min": [
        -3514.0,
        -3545.0,
        1115.0
      ],
      "bbox_max": [
        -3454.0,
        -3445.0,
        1135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3545.0,
        1115.0
      ],
      "bbox_max": [
        -3454.0,
        -3445.0,
        1135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3454.0,
        -3545.0,
        1115.0
      ],
      "bbox_max": [
        -3454.0,
        -3445.0,
        1135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3405.0,
      "bbox_min": [
        -3514.0,
        -3585.0,
        1135.0
      ],
      "bbox_max": [
        -3454.0,
        -3401.411865234375,
        1185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -2866.41357421875,
      "bbox_min": [
        -3514.0,
        -3405.0,
        1175.0
      ],
      "bbox_max": [
        -3468.629638671875,
        -3401.411865234375,
        1183.09716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3405.0,
        1175.0
      ],
      "bbox_max": [
        -3514.0,
        -3401.411865234375,
        1183.09716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1155.0,
      "bbox_min": [
        -3514.0,
        -3585.0,
        1135.0
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3545.0,
      "bbox_min": [
        -3514.0,
        -3585.0,
        1155.0
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3445.0,
      "bbox_min": [
        -3514.0,
        -3445.0,
        1155.0
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3445.0,
        1155.0
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3454.0,
        -3445.0,
        1155.0
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3585.0,
        1155.0
      ],
      "bbox_max": [
        -3454.0,
        -3545.0,
        1185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3454.0,
        -3585.0,
        1155.0
      ],
      "bbox_max": [
        -3454.0,
        -3545.0,
        1185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3515.0,
      "bbox_min": [
        -3514.0,
        -3585.0,
        1135.0
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3475.0,
      "bbox_min": [
        -3514.0,
        -3475.0,
        1135.0
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3475.0,
        1135.0
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3454.0,
        -3475.0,
        1135.0
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3585.0,
        1135.0
      ],
      "bbox_max": [
        -3454.0,
        -3515.0,
        1155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3454.0,
        -3585.0,
        1135.0
      ],
      "bbox_max": [
        -3454.0,
        -3515.0,
        1155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3514.0,
        -3635.0,
        1185.0
      ],
      "bbox_max": [
        -3454.0,
        -3406.19677734375,
        1220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3635.0,
        1185.0
      ],
      "bbox_max": [
        -3454.0,
        -3406.19677734375,
        1220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3545.0,
      "bbox_min": [
        -3514.0,
        -3635.0,
        1185.0
      ],
      "bbox_max": [
        -3454.0,
        -3445.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3445.0,
      "bbox_min": [
        -3514.0,
        -3445.0,
        1185.0
      ],
      "bbox_max": [
        -3454.0,
        -3445.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3635.0,
      "bbox_min": [
        -3514.0,
        -3635.0,
        1185.0
      ],
      "bbox_max": [
        -3454.0,
        -3600.0,
        1220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3514.0,
        -3635.0,
        1185.0
      ],
      "bbox_max": [
        -3454.0,
        -3600.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 1010.9413452148438,
      "bbox_min": [
        -3514.0,
        -3615.0,
        1185.0
      ],
      "bbox_max": [
        -3454.0,
        -3600.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7055787444114685,
        -0.47038400173187256,
        0.5299976468086243
      ],
      "plane_d": 417.880126953125,
      "bbox_min": [
        -3787.0,
        -3434.94384765625,
        1110.0
      ],
      "bbox_max": [
        -3353.0,
        -3085.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8479982614517212,
        0.5299989581108093
      ],
      "plane_d": -3243.80517578125,
      "bbox_min": [
        -3787.0,
        -3370.72265625,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3094.0,
        1208.484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8479983806610107,
        -0.0,
        0.5299989581108093
      ],
      "plane_d": 2591.27099609375,
      "bbox_min": [
        -3787.0,
        -3370.72265625,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3094.0,
        1208.484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.735303521156311,
        -0.4224090576171875,
        0.529999315738678
      ],
      "plane_d": 822.22265625,
      "bbox_min": [
        -3787.0,
        -3370.72265625,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3094.0,
        1208.484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7515174150466919,
        0.39283910393714905,
        0.5299990773200989
      ],
      "plane_d": 3519.23388671875,
      "bbox_min": [
        -3787.0,
        -3370.72265625,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3179.133056640625,
        1208.484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1357402354478836,
        -0.8370640873908997,
        0.5299983024597168
      ],
      "plane_d": -2793.858642578125,
      "bbox_min": [
        -3682.0,
        -3310.72802734375,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3179.133056640625,
        1208.484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3310.72802734375,
        1175.0
      ],
      "bbox_max": [
        -3656.84814453125,
        -3273.0,
        1208.484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        -3682.0,
        -3310.72802734375,
        1175.0
      ],
      "bbox_max": [
        -3656.84814453125,
        -3273.0,
        1208.484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3290.0,
      "bbox_min": [
        -3682.0,
        -3305.0,
        1175.0
      ],
      "bbox_max": [
        -3668.181396484375,
        -3273.0,
        1208.484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3682.0,
        -3288.193603515625,
        1195.0
      ],
      "bbox_max": [
        -3671.87109375,
        -3273.0,
        1208.484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3273.0,
      "bbox_min": [
        -3682.0,
        -3273.0,
        1195.0
      ],
      "bbox_max": [
        -3671.87109375,
        -3273.0,
        1208.484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3305.0,
      "bbox_min": [
        -3682.0,
        -3305.0,
        1175.0
      ],
      "bbox_max": [
        -3678.181396484375,
        -3305.0,
        1180.083740234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        -3682.0,
        -3434.94384765625,
        1110.0
      ],
      "bbox_max": [
        -3353.0,
        -3085.0,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.07677337527275085,
        0.8445155024528503,
        0.5299994349479675
      ],
      "plane_d": 1961.1470947265625,
      "bbox_min": [
        -3682.0,
        -3434.94384765625,
        1110.0
      ],
      "bbox_max": [
        -3353.0,
        -3085.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        -3514.0,
        -3434.94384765625,
        1155.0
      ],
      "bbox_max": [
        -3365.11572265625,
        -3352.985107421875,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1185.0,
      "bbox_min": [
        -3514.0,
        -3434.94384765625,
        1155.0
      ],
      "bbox_max": [
        -3365.11572265625,
        -3352.985107421875,
        1220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -2866.41357421875,
      "bbox_min": [
        -3514.0,
        -3412.931396484375,
        1155.0
      ],
      "bbox_max": [
        -3365.11572265625,
        -3352.985107421875,
        1185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3405.0,
      "bbox_min": [
        -3468.629638671875,
        -3406.156982421875,
        1155.0
      ],
      "bbox_max": [
        -3365.11572265625,
        -3352.985107421875,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5017217993736267,
        0.8650290966033936,
        0.0
      ],
      "plane_d": 4589.81005859375,
      "bbox_min": [
        -3366.888427734375,
        -3353.8759765625,
        1155.0
      ],
      "bbox_max": [
        -3365.11572265625,
        -3352.985107421875,
        1156.3450927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1155.0,
      "bbox_min": [
        -3366.888427734375,
        -3353.8759765625,
        1155.0
      ],
      "bbox_max": [
        -3365.11572265625,
        -3352.985107421875,
        1156.3450927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660268783569336,
        0.4999975860118866,
        0.0
      ],
      "plane_d": -1237.7962646484375,
      "bbox_min": [
        -3365.630126953125,
        -3353.8759765625,
        1155.0
      ],
      "bbox_max": [
        -3365.11572265625,
        -3352.985107421875,
        1156.3450927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3454.0,
        -3406.156982421875,
        1172.3890380859375
      ],
      "bbox_max": [
        -3454.0,
        -3405.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3514.0,
        -3412.931396484375,
        1174.2286376953125
      ],
      "bbox_max": [
        -3454.0,
        -3390.0,
        1185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3406.19677734375,
        1177.39208984375
      ],
      "bbox_max": [
        -3514.0,
        -3390.0,
        1185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -2866.41357421875,
      "bbox_min": [
        -3514.0,
        -3434.94384765625,
        1185.0
      ],
      "bbox_max": [
        -3454.0,
        -3382.8740234375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3514.0,
        -3434.94384765625,
        1185.0
      ],
      "bbox_max": [
        -3454.0,
        -3382.8740234375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3428.209228515625,
        1185.0
      ],
      "bbox_max": [
        -3514.0,
        -3386.719482421875,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.84611976146698,
        0.05640798062086105,
        0.5299997329711914
      ],
      "plane_d": -3318.845703125,
      "bbox_min": [
        -3682.0,
        -3407.3125,
        1110.0
      ],
      "bbox_max": [
        -3353.0,
        -3085.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255074501038,
        0.4999999701976776,
        0.0
      ],
      "plane_d": -1237.7835693359375,
      "bbox_min": [
        -3398.3388671875,
        -3366.64111328125,
        1155.0
      ],
      "bbox_max": [
        -3353.0,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.866025447845459,
        -0.5,
        0.0
      ],
      "plane_d": -4569.783203125,
      "bbox_min": [
        -3398.3388671875,
        -3366.64111328125,
        1155.0
      ],
      "bbox_max": [
        -3353.0,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3398.3388671875,
        -3366.64111328125,
        1155.0
      ],
      "bbox_max": [
        -3353.0,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.5017217993736267,
        -0.8650290966033936,
        0.0
      ],
      "plane_d": -4580.310546875,
      "bbox_min": [
        -3382.874267578125,
        -3353.8759765625,
        1155.0
      ],
      "bbox_max": [
        -3360.880126953125,
        -3335.669921875,
        1195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660268783569336,
        -0.4999975860118866,
        0.0
      ],
      "plane_d": 1247.719482421875,
      "bbox_min": [
        -3382.874267578125,
        -3353.8759765625,
        1155.0
      ],
      "bbox_max": [
        -3360.880126953125,
        -3335.669921875,
        1195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1164.0,
      "bbox_min": [
        -3382.874267578125,
        -3348.897216796875,
        1155.0
      ],
      "bbox_max": [
        -3369.464111328125,
        -3335.669921875,
        1164.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1155.0,
      "bbox_min": [
        -3382.874267578125,
        -3348.897216796875,
        1155.0
      ],
      "bbox_max": [
        -3369.464111328125,
        -3335.669921875,
        1164.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        0.0
      ],
      "plane_d": 4587.34326171875,
      "bbox_min": [
        -3382.874267578125,
        -3348.897216796875,
        1155.0
      ],
      "bbox_max": [
        -3369.464111328125,
        -3335.669921875,
        1164.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        -0.8660230040550232,
        0.0
      ],
      "plane_d": -4577.84326171875,
      "bbox_min": [
        -3382.874267578125,
        -3343.897216796875,
        1155.0
      ],
      "bbox_max": [
        -3369.464111328125,
        -3335.669921875,
        1164.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660268783569336,
        -0.4999975860118866,
        0.0
      ],
      "plane_d": 1257.7196044921875,
      "bbox_min": [
        -3382.874267578125,
        -3343.897216796875,
        1155.0
      ],
      "bbox_max": [
        -3378.124267578125,
        -3335.669921875,
        1164.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5017217993736267,
        0.8650290966033936,
        -0.0
      ],
      "plane_d": 4589.810546875,
      "bbox_min": [
        -3374.214111328125,
        -3353.8759765625,
        1155.0
      ],
      "bbox_max": [
        -3360.880126953125,
        -3340.669921875,
        1195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1155.0,
      "bbox_min": [
        -3374.214111328125,
        -3353.146240234375,
        1155.0
      ],
      "bbox_max": [
        -3360.880126953125,
        -3340.669921875,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3398.3388671875,
        -3366.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3353.0,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3332.0,
      "bbox_min": [
        -3398.3388671875,
        -3366.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3353.0,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8025973439216614,
        -0.5965213179588318,
        0.0
      ],
      "plane_d": 740.216064453125,
      "bbox_min": [
        -3393.919677734375,
        -3332.0,
        1195.0
      ],
      "bbox_max": [
        -3373.0,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3297.35888671875,
      "bbox_min": [
        -3393.919677734375,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3373.0,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1199.7999267578125,
      "bbox_min": [
        -3393.919677734375,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3373.0,
        -3297.35888671875,
        1205.8504638671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3386.89990234375,
      "bbox_min": [
        -3393.919677734375,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3383.8818359375,
        -3299.55908203125,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284762144088745,
        0.0,
        0.3713918626308441
      ],
      "plane_d": -3589.50927734375,
      "bbox_min": [
        -3386.89990234375,
        -3312.0,
        1195.0
      ],
      "bbox_max": [
        -3383.8818359375,
        -3301.1591796875,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3312.0,
      "bbox_min": [
        -3386.89990234375,
        -3312.0,
        1195.0
      ],
      "bbox_max": [
        -3383.8818359375,
        -3312.0,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6804139614105225,
        -0.6804131865501404,
        0.2721666097640991
      ],
      "plane_d": -4877.19140625,
      "bbox_min": [
        -3386.89990234375,
        -3301.958984375,
        1197.800048828125
      ],
      "bbox_max": [
        -3386.10009765625,
        -3301.1591796875,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3317.937744140625,
      "bbox_min": [
        -3393.919677734375,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3386.89990234375,
        -3299.55908203125,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3318.447509765625,
      "bbox_min": [
        -3391.437255859375,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3388.674072265625,
        -3317.937744140625,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999931454658508,
        0.0037271007895469666,
        0.0
      ],
      "plane_d": -3379.046142578125,
      "bbox_min": [
        -3391.437255859375,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3391.435546875,
        -3317.937744140625,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3300.35888671875,
      "bbox_min": [
        -3393.919677734375,
        -3301.958984375,
        1195.0
      ],
      "bbox_max": [
        -3386.89990234375,
        -3299.55908203125,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284761548042297,
        0.37139225006103516
      ],
      "plane_d": -3509.158203125,
      "bbox_min": [
        -3392.165771484375,
        -3300.35888671875,
        1197.800048828125
      ],
      "bbox_max": [
        -3387.7001953125,
        -3299.55908203125,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6804139614105225,
        -0.6804131865501404,
        0.2721666097640991
      ],
      "plane_d": -4877.19140625,
      "bbox_min": [
        -3388.5,
        -3300.35888671875,
        1197.800048828125
      ],
      "bbox_max": [
        -3387.7001953125,
        -3299.55908203125,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071072459220886,
        -0.7071064114570618,
        0.0
      ],
      "plane_d": -4729.73779296875,
      "bbox_min": [
        -3388.5,
        -3301.958984375,
        1195.0
      ],
      "bbox_max": [
        -3386.89990234375,
        -3300.35888671875,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6804139614105225,
        -0.6804131865501404,
        0.2721666097640991
      ],
      "plane_d": -4877.19140625,
      "bbox_min": [
        -3388.5,
        -3301.958984375,
        1197.800048828125
      ],
      "bbox_max": [
        -3386.89990234375,
        -3300.35888671875,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3318.447509765625,
      "bbox_min": [
        -3391.437255859375,
        -3318.447509765625,
        1199.800048828125
      ],
      "bbox_max": [
        -3388.295166015625,
        -3317.937744140625,
        1205.8504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3317.937744140625,
      "bbox_min": [
        -3391.437255859375,
        -3318.447509765625,
        1199.800048828125
      ],
      "bbox_max": [
        -3388.295166015625,
        -3317.937744140625,
        1205.8504638671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999931454658508,
        0.0037271007895469666,
        0.0
      ],
      "plane_d": -3379.046142578125,
      "bbox_min": [
        -3391.437255859375,
        -3318.447509765625,
        1199.800048828125
      ],
      "bbox_max": [
        -3391.435546875,
        -3317.937744140625,
        1200.8887939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8140362501144409,
        -0.5808141231536865,
        0.0
      ],
      "plane_d": -4685.88671875,
      "bbox_min": [
        -3388.674072265625,
        -3332.0,
        1195.0
      ],
      "bbox_max": [
        -3376.619140625,
        -3317.937744140625,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8140390515327454,
        0.5808102488517761,
        -0.0
      ],
      "plane_d": 4685.31982421875,
      "bbox_min": [
        -3388.3095703125,
        -3332.0,
        1195.0
      ],
      "bbox_max": [
        -3376.619140625,
        -3317.937744140625,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1199.0,
      "bbox_min": [
        -3386.033935546875,
        -3327.9833984375,
        1195.0
      ],
      "bbox_max": [
        -3381.38671875,
        -3321.793212890625,
        1199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5739730596542358,
        0.818874180316925,
        0.0
      ],
      "plane_d": 784.1099853515625,
      "bbox_min": [
        -3386.033935546875,
        -3327.9833984375,
        1195.0
      ],
      "bbox_max": [
        -3381.38671875,
        -3321.793212890625,
        1199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5739685297012329,
        -0.8188773989677429,
        0.0
      ],
      "plane_d": -776.92919921875,
      "bbox_min": [
        -3386.033935546875,
        -3322.11669921875,
        1195.0
      ],
      "bbox_max": [
        -3385.57275390625,
        -3321.793212890625,
        1199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3317.937744140625,
      "bbox_min": [
        -3388.295166015625,
        -3328.06689453125,
        1195.0
      ],
      "bbox_max": [
        -3376.619140625,
        -3317.937744140625,
        1205.8604736328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8140378594398499,
        0.5808117985725403,
        -2.9502823508664733e-06
      ],
      "plane_d": 4679.82470703125,
      "bbox_min": [
        -3385.863037109375,
        -3328.06689453125,
        1195.0
      ],
      "bbox_max": [
        -3376.619140625,
        -3318.191650390625,
        1199.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5808116793632507,
        0.8140379786491394,
        0.0
      ],
      "plane_d": 737.1856689453125,
      "bbox_min": [
        -3385.863037109375,
        -3328.06689453125,
        1195.0
      ],
      "bbox_max": [
        -3376.619140625,
        -3318.191650390625,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5808116793632507,
        -0.8140379786491394,
        0.0
      ],
      "plane_d": -745.3927001953125,
      "bbox_min": [
        -3385.57275390625,
        -3328.06689453125,
        1195.0
      ],
      "bbox_max": [
        -3376.619140625,
        -3318.598876953125,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1199.0,
      "bbox_min": [
        -3385.57275390625,
        -3327.659912109375,
        1195.0
      ],
      "bbox_max": [
        -3376.90966796875,
        -3318.598876953125,
        1199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5808116793632507,
        -0.8140379786491394,
        0.0
      ],
      "plane_d": -737.6856689453125,
      "bbox_min": [
        -3385.57275390625,
        -3327.659912109375,
        1195.0
      ],
      "bbox_max": [
        -3376.90966796875,
        -3318.598876953125,
        1199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5808116793632507,
        0.8140379786491394,
        0.0
      ],
      "plane_d": 744.8927001953125,
      "bbox_min": [
        -3381.38671875,
        -3327.659912109375,
        1195.0
      ],
      "bbox_max": [
        -3376.90966796875,
        -3324.465576171875,
        1199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3318.447509765625,
      "bbox_min": [
        -3388.674072265625,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3388.659423828125,
        -3318.447509765625,
        1205.3236083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.64111328125,
      "bbox_min": [
        -3398.3388671875,
        -3366.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3373.0,
        -3332.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8025972843170166,
        0.5965211987495422,
        0.0
      ],
      "plane_d": 4715.43359375,
      "bbox_min": [
        -3396.459228515625,
        -3366.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3373.0,
        -3332.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3345.552490234375,
      "bbox_min": [
        -3396.459228515625,
        -3366.639892578125,
        1195.0
      ],
      "bbox_max": [
        -3388.0,
        -3345.552490234375,
        1208.853759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3346.062255859375,
      "bbox_min": [
        -3396.459228515625,
        -3366.639892578125,
        1195.0
      ],
      "bbox_max": [
        -3388.0,
        -3345.552490234375,
        1208.853759765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999931454658508,
        -0.0037271007895469666,
        0.0
      ],
      "plane_d": -3403.883544921875,
      "bbox_min": [
        -3391.437255859375,
        -3346.062255859375,
        1195.0
      ],
      "bbox_max": [
        -3391.435546875,
        -3345.552490234375,
        1203.8304443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0400390625,
      "bbox_min": [
        -3396.459228515625,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3388.0,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1199.5,
      "bbox_min": [
        -3396.459228515625,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3388.0,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1198.0,
      "bbox_min": [
        -3396.459228515625,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3388.0,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3391.5,
      "bbox_min": [
        -3395.0,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3388.0,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3395.0,
      "bbox_min": [
        -3395.0,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3394.0,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3394.0,
      "bbox_min": [
        -3394.0,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3394.0,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3388.0,
      "bbox_min": [
        -3390.5,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3388.0,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3390.5,
      "bbox_min": [
        -3390.5,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3390.5,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8140362501144409,
        0.5808140635490417,
        0.0
      ],
      "plane_d": -815.341552734375,
      "bbox_min": [
        -3388.674072265625,
        -3346.042724609375,
        1195.0
      ],
      "bbox_max": [
        -3378.290283203125,
        -3332.0,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8140383958816528,
        -0.5808111429214478,
        0.0
      ],
      "plane_d": 814.795166015625,
      "bbox_min": [
        -3388.3095703125,
        -3346.042724609375,
        1195.0
      ],
      "bbox_max": [
        -3378.290283203125,
        -3332.0,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5739730596542358,
        -0.818874180316925,
        0.0
      ],
      "plane_d": -4672.86767578125,
      "bbox_min": [
        -3386.033935546875,
        -3342.206787109375,
        1195.0
      ],
      "bbox_max": [
        -3381.38671875,
        -3336.0166015625,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5739685297012329,
        0.8188773989677429,
        0.0
      ],
      "plane_d": 4680.06982421875,
      "bbox_min": [
        -3386.033935546875,
        -3342.206787109375,
        1195.0
      ],
      "bbox_max": [
        -3381.38671875,
        -3336.0166015625,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1205.0,
      "bbox_min": [
        -3386.033935546875,
        -3342.206787109375,
        1205.0
      ],
      "bbox_max": [
        -3381.38671875,
        -3336.0166015625,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3345.552490234375,
      "bbox_min": [
        -3388.674072265625,
        -3345.552490234375,
        1195.0
      ],
      "bbox_max": [
        -3388.659423828125,
        -3345.552490234375,
        1208.2081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3320.0,
      "bbox_min": [
        -3682.0,
        -3407.3125,
        1110.0
      ],
      "bbox_max": [
        -3381.19189453125,
        -3085.0,
        1235.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3335.0,
      "bbox_min": [
        -3682.0,
        -3407.3125,
        1110.0
      ],
      "bbox_max": [
        -3382.701416015625,
        -3320.0,
        1235.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        -3682.0,
        -3335.0,
        1110.0
      ],
      "bbox_max": [
        -3382.701416015625,
        -3320.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1170.0,
      "bbox_min": [
        -3524.0,
        -3335.0,
        1110.0
      ],
      "bbox_max": [
        -3439.95458984375,
        -3320.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4248773753643036,
        0.7338800430297852,
        0.5299993753433228
      ],
      "plane_d": 362.9822998046875,
      "bbox_min": [
        -3521.506103515625,
        -3335.0,
        1110.0
      ],
      "bbox_max": [
        -3439.95458984375,
        -3320.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7444531917572021,
        0.40606623888015747,
        0.5299997329711914
      ],
      "plane_d": -1832.8450927734375,
      "bbox_min": [
        -3465.484375,
        -3335.0,
        1134.14013671875
      ],
      "bbox_max": [
        -3439.95458984375,
        -3320.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3329.64111328125,
      "bbox_min": [
        -3524.0,
        -3329.64111328125,
        1170.0
      ],
      "bbox_max": [
        -3444.0,
        -3320.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3444.0,
      "bbox_min": [
        -3524.0,
        -3329.64111328125,
        1170.0
      ],
      "bbox_max": [
        -3444.0,
        -3320.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3524.0,
        -3329.64111328125,
        1170.0
      ],
      "bbox_max": [
        -3524.0,
        -3320.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3329.64111328125,
      "bbox_min": [
        -3682.0,
        -3335.0,
        1175.0
      ],
      "bbox_max": [
        -3382.701416015625,
        -3320.0,
        1235.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3335.0,
        1175.0
      ],
      "bbox_max": [
        -3383.34423828125,
        -3329.64111328125,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.765704870223999,
        0.0,
        -0.6431921124458313
      ],
      "plane_d": -1943.818359375,
      "bbox_min": [
        -3682.0,
        -3335.0,
        1175.0
      ],
      "bbox_max": [
        -3383.34423828125,
        -3329.64111328125,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3332.0,
      "bbox_min": [
        -3491.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3383.34423828125,
        -3329.64111328125,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3491.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3383.50146484375,
        -3332.0,
        1215.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8660255074501038,
        0.4999999701976776,
        -0.0
      ],
      "plane_d": 4639.0654296875,
      "bbox_min": [
        -3491.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3405.522705078125,
        -3332.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3491.0,
      "bbox_min": [
        -3491.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3332.0,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3477.0,
      "bbox_min": [
        -3491.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3332.0,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        -3491.0,
        -3335.0,
        1210.0
      ],
      "bbox_max": [
        -3477.0,
        -3332.0,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8971250057220459,
        0.4417768120765686,
        -0.0
      ],
      "plane_d": 4528.50537109375,
      "bbox_min": [
        -3407.557373046875,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3405.522705078125,
        -3332.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8971262574195862,
        -0.44177424907684326,
        -0.0
      ],
      "plane_d": -4529.0009765625,
      "bbox_min": [
        -3407.557373046875,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3406.080078125,
        -3332.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3491.0,
        -3332.0,
        1195.0
      ],
      "bbox_max": [
        -3383.34423828125,
        -3329.64111328125,
        1215.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3433.0,
      "bbox_min": [
        -3491.0,
        -3332.0,
        1195.0
      ],
      "bbox_max": [
        -3405.901611328125,
        -3329.64111328125,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3491.0,
      "bbox_min": [
        -3491.0,
        -3332.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3329.64111328125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3477.0,
      "bbox_min": [
        -3491.0,
        -3332.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3329.64111328125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        -3491.0,
        -3332.0,
        1210.0
      ],
      "bbox_max": [
        -3477.0,
        -3329.64111328125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.894890546798706,
        -0.4462857246398926,
        0.0
      ],
      "plane_d": 1561.9378662109375,
      "bbox_min": [
        -3407.652587890625,
        -3332.0,
        1195.0
      ],
      "bbox_max": [
        -3405.901611328125,
        -3329.64111328125,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8948920965194702,
        0.4462827146053314,
        0.0
      ],
      "plane_d": -1562.4671630859375,
      "bbox_min": [
        -3407.652587890625,
        -3332.0,
        1195.0
      ],
      "bbox_max": [
        -3406.47607421875,
        -3329.64111328125,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3682.0,
        -3335.0,
        1175.0
      ],
      "bbox_max": [
        -3555.0,
        -3329.64111328125,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3669.0,
        -3335.0,
        1175.0
      ],
      "bbox_max": [
        -3587.0,
        -3329.64111328125,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3669.0,
      "bbox_min": [
        -3669.0,
        -3335.0,
        1194.0
      ],
      "bbox_max": [
        -3669.0,
        -3329.64111328125,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3587.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3329.64111328125,
        1235.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3587.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3585.0,
        -3329.64111328125,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3333.0,
      "bbox_min": [
        -3587.0,
        -3333.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3329.64111328125,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1211.5,
      "bbox_min": [
        -3587.0,
        -3333.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3329.64111328125,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1198.5,
      "bbox_min": [
        -3587.0,
        -3333.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3329.64111328125,
        1198.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3333.0,
      "bbox_min": [
        -3585.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3329.64111328125,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3576.0,
      "bbox_min": [
        -3585.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3333.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1211.5,
      "bbox_min": [
        -3585.0,
        -3335.0,
        1211.5
      ],
      "bbox_max": [
        -3576.0,
        -3333.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3555.0,
      "bbox_min": [
        -3555.0,
        -3335.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3333.0,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3555.0,
      "bbox_min": [
        -3555.0,
        -3333.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3329.64111328125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3682.0,
        -3329.64111328125,
        1175.0
      ],
      "bbox_max": [
        -3382.701416015625,
        -3320.0,
        1235.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.0,
      "bbox_min": [
        -3682.0,
        -3329.64111328125,
        1175.0
      ],
      "bbox_max": [
        -3444.0,
        -3320.0,
        1195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3682.0,
        -3329.64111328125,
        1192.0
      ],
      "bbox_max": [
        -3444.0,
        -3320.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3524.0,
        -3329.64111328125,
        1192.0
      ],
      "bbox_max": [
        -3444.0,
        -3320.0,
        1195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3444.0,
      "bbox_min": [
        -3444.0,
        -3329.64111328125,
        1192.0
      ],
      "bbox_max": [
        -3444.0,
        -3320.0,
        1195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3329.64111328125,
        1192.0
      ],
      "bbox_max": [
        -3669.0,
        -3320.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3669.0,
      "bbox_min": [
        -3669.0,
        -3329.64111328125,
        1194.0
      ],
      "bbox_max": [
        -3669.0,
        -3320.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3682.0,
        -3329.64111328125,
        1175.0
      ],
      "bbox_max": [
        -3444.0,
        -3320.0,
        1192.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3443.999755859375,
      "bbox_min": [
        -3524.0,
        -3329.64111328125,
        1175.0
      ],
      "bbox_max": [
        -3444.0,
        -3320.0,
        1192.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3524.0,
        -3329.64111328125,
        1175.0
      ],
      "bbox_max": [
        -3524.0,
        -3320.0,
        1192.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3382.701416015625,
        -3320.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3433.0,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3382.701416015625,
        -3320.0,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3433.0,
      "bbox_min": [
        -3433.0,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3383.055908203125,
        -3320.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8948943018913269,
        -0.4462781548500061,
        0.0
      ],
      "plane_d": 1561.975830078125,
      "bbox_min": [
        -3406.476318359375,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3383.055908203125,
        -3320.0,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8948925137519836,
        0.44628196954727173,
        0.0
      ],
      "plane_d": -1562.47119140625,
      "bbox_min": [
        -3406.476318359375,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3401.66796875,
        -3320.0,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.43932992219924927,
        -0.8983258008956909,
        -0.0
      ],
      "plane_d": -4479.38134765625,
      "bbox_min": [
        -3405.703125,
        -3328.317138671875,
        1195.0
      ],
      "bbox_max": [
        -3402.3154296875,
        -3322.223876953125,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4393179714679718,
        0.8983317017555237,
        -0.0
      ],
      "plane_d": 4485.91650390625,
      "bbox_min": [
        -3405.703125,
        -3328.317138671875,
        1195.0
      ],
      "bbox_max": [
        -3402.3154296875,
        -3322.223876953125,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1205.0,
      "bbox_min": [
        -3405.703125,
        -3328.317138671875,
        1205.0
      ],
      "bbox_max": [
        -3402.3154296875,
        -3322.223876953125,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8140372633934021,
        -0.5808126926422119,
        0.0
      ],
      "plane_d": -4685.8857421875,
      "bbox_min": [
        -3387.544189453125,
        -3326.207275390625,
        1207.2686767578125
      ],
      "bbox_max": [
        -3383.055908203125,
        -3320.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8140390515327454,
        0.5808102488517761,
        -0.0
      ],
      "plane_d": 4685.31982421875,
      "bbox_min": [
        -3386.85205078125,
        -3325.320556640625,
        1208.373291015625
      ],
      "bbox_max": [
        -3383.055908203125,
        -3320.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3587.0,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3524.0,
        -3320.0,
        1235.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.765704870223999,
        0.0,
        -0.6431921124458313
      ],
      "plane_d": -1943.818359375,
      "bbox_min": [
        -3587.0,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3320.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3587.0,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3320.0,
        1235.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3587.0,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3585.0,
        -3320.0,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -3587.0,
        -3329.64111328125,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3322.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1211.5,
      "bbox_min": [
        -3587.0,
        -3329.64111328125,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3322.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1198.5,
      "bbox_min": [
        -3587.0,
        -3329.64111328125,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3322.0,
        1198.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3555.0,
      "bbox_min": [
        -3585.0,
        -3329.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3320.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -3585.0,
        -3322.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3320.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3576.0,
      "bbox_min": [
        -3585.0,
        -3322.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3320.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1211.5,
      "bbox_min": [
        -3585.0,
        -3322.0,
        1211.5
      ],
      "bbox_max": [
        -3576.0,
        -3320.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        8.030941955894377e-08,
        1.0,
        -0.0
      ],
      "plane_d": 3353.000244140625,
      "bbox_min": [
        -3682.0,
        -3407.3125,
        1110.0
      ],
      "bbox_max": [
        -3383.701416015625,
        -3335.0,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        -3525.3955078125,
        -3407.3125,
        1131.8062744140625
      ],
      "bbox_max": [
        -3384.9013671875,
        -3353.0,
        1220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3525.3955078125,
        -3407.3125,
        1131.8062744140625
      ],
      "bbox_max": [
        -3384.9013671875,
        -3353.0,
        1220.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3514.0,
        -3388.8544921875,
        1187.1868896484375
      ],
      "bbox_max": [
        -3454.0,
        -3375.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3388.8544921875,
        1187.1868896484375
      ],
      "bbox_max": [
        -3514.0,
        -3386.502197265625,
        1190.5888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -2866.41357421875,
      "bbox_min": [
        -3514.0,
        -3391.622802734375,
        1187.331787109375
      ],
      "bbox_max": [
        -3484.567138671875,
        -3375.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3391.622802734375,
        1187.331787109375
      ],
      "bbox_max": [
        -3514.0,
        -3375.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -3514.0,
        -3407.3125,
        1195.0
      ],
      "bbox_max": [
        -3384.9013671875,
        -3353.0,
        1220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3454.0,
        -3401.85791015625,
        1195.0
      ],
      "bbox_max": [
        -3384.9013671875,
        -3353.0,
        1220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.64111328125,
      "bbox_min": [
        -3420.875732421875,
        -3366.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3384.9013671875,
        -3353.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3420.875732421875,
        -3366.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3384.9013671875,
        -3353.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8571218848228455,
        -0.5151135921478271,
        0.0
      ],
      "plane_d": 1191.154296875,
      "bbox_min": [
        -3420.875732421875,
        -3366.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3395.47998046875,
        -3353.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660255074501038,
        0.4999999701976776,
        -0.0
      ],
      "plane_d": 4639.0654296875,
      "bbox_min": [
        -3420.875732421875,
        -3366.64111328125,
        1195.0
      ],
      "bbox_max": [
        -3413.0,
        -3353.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0400390625,
      "bbox_min": [
        -3397.5,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3395.47998046875,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1199.5,
      "bbox_min": [
        -3397.5,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3395.47998046875,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3397.5,
      "bbox_min": [
        -3397.5,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3396.41943359375,
        -3366.0400390625,
        1199.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1198.0,
      "bbox_min": [
        -3397.5,
        -3366.639892578125,
        1198.0
      ],
      "bbox_max": [
        -3396.41943359375,
        -3366.0400390625,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        -3682.0,
        -3353.0,
        1110.0
      ],
      "bbox_max": [
        -3383.701416015625,
        -3335.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4248773753643036,
        0.7338800430297852,
        0.5299993753433228
      ],
      "plane_d": 362.9822998046875,
      "bbox_min": [
        -3529.622802734375,
        -3353.0,
        1110.0
      ],
      "bbox_max": [
        -3448.136474609375,
        -3335.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7444531917572021,
        0.40606623888015747,
        0.5299997329711914
      ],
      "plane_d": -1832.8450927734375,
      "bbox_min": [
        -3450.097900390625,
        -3336.248291015625,
        1167.2449951171875
      ],
      "bbox_max": [
        -3448.136474609375,
        -3335.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3682.0,
        -3353.0,
        1175.0
      ],
      "bbox_max": [
        -3587.0,
        -3335.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3353.0,
        1175.0
      ],
      "bbox_max": [
        -3682.0,
        -3335.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        -3682.0,
        -3353.0,
        1195.0
      ],
      "bbox_max": [
        -3383.701416015625,
        -3335.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.765704870223999,
        0.0,
        -0.6431921124458313
      ],
      "plane_d": -1943.818359375,
      "bbox_min": [
        -3682.0,
        -3353.0,
        1220.0
      ],
      "bbox_max": [
        -3563.39990234375,
        -3335.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3682.0,
        -3353.0,
        1220.0
      ],
      "bbox_max": [
        -3585.0,
        -3335.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3353.0,
        1220.0
      ],
      "bbox_max": [
        -3587.0,
        -3335.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3587.0,
        -3353.0,
        1220.0
      ],
      "bbox_max": [
        -3587.0,
        -3335.0,
        1235.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3350.0,
      "bbox_min": [
        -3682.0,
        -3353.0,
        1195.0
      ],
      "bbox_max": [
        -3383.701416015625,
        -3335.0,
        1220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3383.701416015625,
        -3335.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255074501038,
        0.4999999701976776,
        -0.0
      ],
      "plane_d": 4639.0654296875,
      "bbox_min": [
        -3626.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3383.701416015625,
        -3335.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3555.0,
      "bbox_min": [
        -3626.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3335.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3491.0,
      "bbox_min": [
        -3491.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3335.0,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3477.0,
      "bbox_min": [
        -3491.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3335.0,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        -3491.0,
        -3350.0,
        1210.0
      ],
      "bbox_max": [
        -3477.0,
        -3335.0,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3626.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3335.0,
        1220.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.765704870223999,
        0.0,
        -0.6431921124458313
      ],
      "plane_d": -1943.818359375,
      "bbox_min": [
        -3587.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3335.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3337.0,
      "bbox_min": [
        -3587.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3335.0,
        1220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3576.0,
      "bbox_min": [
        -3585.0,
        -3337.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3335.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1211.5,
      "bbox_min": [
        -3585.0,
        -3337.0,
        1211.5
      ],
      "bbox_max": [
        -3576.0,
        -3335.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3585.0,
        -3337.0,
        1211.5
      ],
      "bbox_max": [
        -3585.0,
        -3335.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3587.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3585.0,
        -3337.0,
        1220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1211.5,
      "bbox_min": [
        -3587.0,
        -3348.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3337.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1198.5,
      "bbox_min": [
        -3587.0,
        -3348.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3337.0,
        1198.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3620.0,
      "bbox_min": [
        -3626.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3614.0,
        -3338.0,
        1205.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1205.25,
      "bbox_min": [
        -3626.0,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3620.0,
        -3338.0,
        1205.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3338.0,
      "bbox_min": [
        -3626.0,
        -3338.0,
        1195.0
      ],
      "bbox_max": [
        -3620.0,
        -3338.0,
        1205.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1201.0,
      "bbox_min": [
        -3620.0,
        -3348.0,
        1195.0
      ],
      "bbox_max": [
        -3614.0,
        -3341.0,
        1201.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3614.0,
      "bbox_min": [
        -3620.0,
        -3348.0,
        1195.0
      ],
      "bbox_max": [
        -3614.0,
        -3341.0,
        1201.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3348.0,
      "bbox_min": [
        -3620.0,
        -3348.0,
        1195.0
      ],
      "bbox_max": [
        -3614.0,
        -3341.0,
        1201.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3341.0,
      "bbox_min": [
        -3620.0,
        -3341.0,
        1195.0
      ],
      "bbox_max": [
        -3614.0,
        -3341.0,
        1201.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3431.26806640625,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3383.701416015625,
        -3335.0,
        1215.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.897125244140625,
        0.441776305437088,
        0.0
      ],
      "plane_d": 4528.50439453125,
      "bbox_min": [
        -3406.080078125,
        -3346.062255859375,
        1195.0
      ],
      "bbox_max": [
        -3400.325927734375,
        -3335.0,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8971262574195862,
        -0.44177424907684326,
        -0.0
      ],
      "plane_d": -4529.0009765625,
      "bbox_min": [
        -3406.080078125,
        -3346.062255859375,
        1195.0
      ],
      "bbox_max": [
        -3400.325927734375,
        -3335.0,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3345.552490234375,
      "bbox_min": [
        -3405.435791015625,
        -3345.552490234375,
        1195.0
      ],
      "bbox_max": [
        -3400.325927734375,
        -3336.08740234375,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4417732059955597,
        0.8971267342567444,
        0.0
      ],
      "plane_d": 1495.07666015625,
      "bbox_min": [
        -3405.435791015625,
        -3342.06396484375,
        1195.0
      ],
      "bbox_max": [
        -3402.15283203125,
        -3336.08740234375,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4417732059955597,
        -0.8971267342567444,
        0.0
      ],
      "plane_d": -1488.6611328125,
      "bbox_min": [
        -3405.435791015625,
        -3342.06396484375,
        1195.0
      ],
      "bbox_max": [
        -3402.15283203125,
        -3336.08740234375,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1205.0,
      "bbox_min": [
        -3405.435791015625,
        -3342.06396484375,
        1205.0
      ],
      "bbox_max": [
        -3402.15283203125,
        -3336.08740234375,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3346.062255859375,
      "bbox_min": [
        -3400.665771484375,
        -3346.062255859375,
        1195.0
      ],
      "bbox_max": [
        -3400.63232421875,
        -3346.062255859375,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3346.062255859375,
      "bbox_min": [
        -3400.63232421875,
        -3350.0,
        1195.0
      ],
      "bbox_max": [
        -3383.96728515625,
        -3338.98681640625,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999931454658508,
        0.0037121325731277466,
        0.0
      ],
      "plane_d": 3410.2490234375,
      "bbox_min": [
        -3400.325927734375,
        -3346.062255859375,
        1195.0
      ],
      "bbox_max": [
        -3383.96728515625,
        -3338.98681640625,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3345.552490234375,
      "bbox_min": [
        -3400.325927734375,
        -3345.552490234375,
        1195.0
      ],
      "bbox_max": [
        -3397.85302734375,
        -3345.552490234375,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3345.552490234375,
      "bbox_min": [
        -3397.85302734375,
        -3346.062255859375,
        1203.7733154296875
      ],
      "bbox_max": [
        -3383.96728515625,
        -3338.98681640625,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999931454658508,
        -0.0037271007895469666,
        0.0
      ],
      "plane_d": -3403.883544921875,
      "bbox_min": [
        -3391.437255859375,
        -3346.062255859375,
        1203.7733154296875
      ],
      "bbox_max": [
        -3391.435546875,
        -3345.552490234375,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8140372633934021,
        0.5808126330375671,
        0.0
      ],
      "plane_d": -815.349609375,
      "bbox_min": [
        -3388.66259765625,
        -3346.042724609375,
        1208.2047119140625
      ],
      "bbox_max": [
        -3387.959716796875,
        -3345.552490234375,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8140383958816528,
        -0.5808111429214478,
        0.0
      ],
      "plane_d": 814.795166015625,
      "bbox_min": [
        -3388.65185546875,
        -3345.552490234375,
        1208.2203369140625
      ],
      "bbox_max": [
        -3383.96728515625,
        -3338.98681640625,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8140378594398499,
        0.5808118581771851,
        1.3893710502088652e-06
      ],
      "plane_d": -815.3560791015625,
      "bbox_min": [
        -3388.65185546875,
        -3345.552490234375,
        1208.2203369140625
      ],
      "bbox_max": [
        -3383.96728515625,
        -3338.98681640625,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8025972843170166,
        0.5965211987495422,
        0.0
      ],
      "plane_d": 4715.43359375,
      "bbox_min": [
        -3388.294921875,
        -3350.0,
        1208.8438720703125
      ],
      "bbox_max": [
        -3385.368408203125,
        -3346.062255859375,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3353.0,
        1195.0
      ],
      "bbox_max": [
        -3384.701416015625,
        -3350.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3626.0,
        -3353.0,
        1195.0
      ],
      "bbox_max": [
        -3384.701416015625,
        -3350.0,
        1220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8571218848228455,
        -0.5151135921478271,
        0.0
      ],
      "plane_d": 1191.154296875,
      "bbox_min": [
        -3422.60791015625,
        -3353.0,
        1195.0
      ],
      "bbox_max": [
        -3384.701416015625,
        -3350.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660255074501038,
        0.4999999701976776,
        -0.0
      ],
      "plane_d": 4639.0654296875,
      "bbox_min": [
        -3422.60791015625,
        -3353.0,
        1195.0
      ],
      "bbox_max": [
        -3402.9990234375,
        -3350.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3422.60791015625,
        -3353.0,
        1215.0
      ],
      "bbox_max": [
        -3402.9990234375,
        -3350.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3404.802001953125,
        -3353.0,
        1213.935302734375
      ],
      "bbox_max": [
        -3384.701416015625,
        -3350.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3555.0,
      "bbox_min": [
        -3585.0,
        -3353.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3350.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3585.0,
        -3353.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3350.0,
        1220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.765704870223999,
        0.0,
        -0.6431921124458313
      ],
      "plane_d": -1943.818359375,
      "bbox_min": [
        -3563.39990234375,
        -3353.0,
        1210.0
      ],
      "bbox_max": [
        -3555.0,
        -3350.0,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3351.0,
      "bbox_min": [
        -3626.0,
        -3351.0,
        1195.0
      ],
      "bbox_max": [
        -3620.0,
        -3350.0,
        1205.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3620.0,
      "bbox_min": [
        -3626.0,
        -3351.0,
        1195.0
      ],
      "bbox_max": [
        -3620.0,
        -3350.0,
        1205.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1205.25,
      "bbox_min": [
        -3626.0,
        -3351.0,
        1205.25
      ],
      "bbox_max": [
        -3620.0,
        -3350.0,
        1205.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3305.0,
      "bbox_min": [
        -3682.0,
        -3320.0,
        1110.0
      ],
      "bbox_max": [
        -3381.19189453125,
        -3085.0,
        1235.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -3236.173828125,
      "bbox_min": [
        -3682.0,
        -3305.0,
        1110.0
      ],
      "bbox_max": [
        -3381.19189453125,
        -3085.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3682.0,
        -3305.0,
        1110.0
      ],
      "bbox_max": [
        -3381.19189453125,
        -3085.0,
        1235.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3273.0,
      "bbox_min": [
        -3682.0,
        -3290.0,
        1175.0
      ],
      "bbox_max": [
        -3555.0,
        -3273.0,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3682.0,
        -3290.0,
        1175.0
      ],
      "bbox_max": [
        -3555.0,
        -3273.0,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        -3682.0,
        -3290.0,
        1175.0
      ],
      "bbox_max": [
        -3587.0,
        -3273.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3290.0,
        1193.396484375
      ],
      "bbox_max": [
        -3682.0,
        -3288.193359375,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3290.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3273.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.765704870223999,
        0.0,
        -0.6431921124458313
      ],
      "plane_d": -1943.818359375,
      "bbox_min": [
        -3610.5,
        -3290.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3273.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3610.5,
        -3290.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3273.0,
        1235.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3587.0,
        -3290.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3273.0,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3277.0,
      "bbox_min": [
        -3587.0,
        -3288.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3277.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3288.0,
      "bbox_min": [
        -3587.0,
        -3288.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3277.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1198.5,
      "bbox_min": [
        -3587.0,
        -3288.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3277.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1211.5,
      "bbox_min": [
        -3587.0,
        -3288.0,
        1211.5
      ],
      "bbox_max": [
        -3585.0,
        -3277.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3555.0,
      "bbox_min": [
        -3585.0,
        -3290.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3273.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3288.0,
      "bbox_min": [
        -3585.0,
        -3290.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3288.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3576.0,
      "bbox_min": [
        -3585.0,
        -3290.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3288.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1211.5,
      "bbox_min": [
        -3585.0,
        -3290.0,
        1211.5
      ],
      "bbox_max": [
        -3576.0,
        -3288.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1197.0,
      "bbox_min": [
        -3610.5,
        -3287.0,
        1195.0
      ],
      "bbox_max": [
        -3607.0,
        -3279.0,
        1197.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3607.0,
      "bbox_min": [
        -3610.5,
        -3287.0,
        1195.0
      ],
      "bbox_max": [
        -3607.0,
        -3279.0,
        1197.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3287.0,
      "bbox_min": [
        -3610.5,
        -3287.0,
        1195.0
      ],
      "bbox_max": [
        -3607.0,
        -3279.0,
        1197.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3279.0,
      "bbox_min": [
        -3610.5,
        -3279.0,
        1195.0
      ],
      "bbox_max": [
        -3607.0,
        -3279.0,
        1197.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        -3682.0,
        -3305.0,
        1175.0
      ],
      "bbox_max": [
        -3555.0,
        -3290.0,
        1235.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3305.0,
        1175.0
      ],
      "bbox_max": [
        -3555.0,
        -3290.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.765704870223999,
        0.0,
        -0.6431921124458313
      ],
      "plane_d": -1943.818359375,
      "bbox_min": [
        -3641.5,
        -3305.0,
        1175.0
      ],
      "bbox_max": [
        -3555.0,
        -3290.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3641.5,
        -3305.0,
        1175.0
      ],
      "bbox_max": [
        -3555.0,
        -3290.0,
        1235.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3641.5,
        -3305.0,
        1175.0
      ],
      "bbox_max": [
        -3587.0,
        -3290.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.0,
      "bbox_min": [
        -3641.5,
        -3302.0,
        1175.0
      ],
      "bbox_max": [
        -3638.0,
        -3294.0,
        1177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3641.5,
      "bbox_min": [
        -3641.5,
        -3302.0,
        1175.0
      ],
      "bbox_max": [
        -3638.0,
        -3294.0,
        1177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3638.0,
      "bbox_min": [
        -3641.5,
        -3302.0,
        1175.0
      ],
      "bbox_max": [
        -3638.0,
        -3294.0,
        1177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3302.0,
      "bbox_min": [
        -3641.5,
        -3302.0,
        1175.0
      ],
      "bbox_max": [
        -3638.0,
        -3294.0,
        1177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3294.0,
      "bbox_min": [
        -3641.5,
        -3294.0,
        1175.0
      ],
      "bbox_max": [
        -3638.0,
        -3294.0,
        1177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3587.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3290.0,
        1235.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3587.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3585.0,
        -3290.0,
        1235.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3292.0,
      "bbox_min": [
        -3587.0,
        -3303.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3292.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3303.0,
      "bbox_min": [
        -3587.0,
        -3303.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3292.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1211.5,
      "bbox_min": [
        -3587.0,
        -3303.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3292.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1198.5,
      "bbox_min": [
        -3587.0,
        -3303.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3292.0,
        1198.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3555.0,
      "bbox_min": [
        -3585.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3555.0,
        -3290.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3292.0,
      "bbox_min": [
        -3585.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3290.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3576.0,
      "bbox_min": [
        -3585.0,
        -3292.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3290.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1211.5,
      "bbox_min": [
        -3585.0,
        -3292.0,
        1211.5
      ],
      "bbox_max": [
        -3576.0,
        -3290.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3303.0,
      "bbox_min": [
        -3585.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3303.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3576.0,
      "bbox_min": [
        -3585.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3303.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1211.5,
      "bbox_min": [
        -3585.0,
        -3305.0,
        1211.5
      ],
      "bbox_max": [
        -3576.0,
        -3303.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3444.0,
      "bbox_min": [
        -3524.0,
        -3305.0,
        1110.0
      ],
      "bbox_max": [
        -3381.19189453125,
        -3085.0,
        1235.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7794328927993774,
        -0.3340444266796112,
        0.5299988985061646
      ],
      "plane_d": -4326.4423828125,
      "bbox_min": [
        -3444.0,
        -3305.0,
        1110.0
      ],
      "bbox_max": [
        -3381.19189453125,
        -3085.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3297.35888671875,
      "bbox_min": [
        -3413.974853515625,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3381.19189453125,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3413.974853515625,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3381.19189453125,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8571218848228455,
        -0.5151137113571167,
        -0.0
      ],
      "plane_d": -4623.87158203125,
      "bbox_min": [
        -3411.326171875,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3390.712890625,
        -3297.35888671875,
        1202.8193359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1199.800048828125,
      "bbox_min": [
        -3409.53466796875,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3390.712890625,
        -3297.35888671875,
        1199.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9284761548042297,
        0.37139225006103516
      ],
      "plane_d": -3509.158203125,
      "bbox_min": [
        -3401.89990234375,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3390.859619140625,
        -3299.55908203125,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3300.35888671875,
      "bbox_min": [
        -3400.6201171875,
        -3301.47900390625,
        1195.0
      ],
      "bbox_max": [
        -3392.165771484375,
        -3300.35888671875,
        1197.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071072459220886,
        -0.7071064114570618,
        0.0
      ],
      "plane_d": 70.106201171875,
      "bbox_min": [
        -3400.6201171875,
        -3301.47900390625,
        1195.0
      ],
      "bbox_max": [
        -3399.5,
        -3300.35888671875,
        1197.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3401.10009765625,
      "bbox_min": [
        -3401.89990234375,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3399.5,
        -3299.55908203125,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284762144088745,
        -0.0,
        0.3713918626308441
      ],
      "plane_d": 2712.9873046875,
      "bbox_min": [
        -3401.89990234375,
        -3305.0,
        1197.800048828125
      ],
      "bbox_max": [
        -3401.10009765625,
        -3301.1591796875,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6804140210151672,
        -0.6804131865501404,
        0.2721666097640991
      ],
      "plane_d": -258.54150390625,
      "bbox_min": [
        -3401.89990234375,
        -3301.958984375,
        1197.800048828125
      ],
      "bbox_max": [
        -3401.10009765625,
        -3301.1591796875,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071072459220886,
        -0.7071064114570618,
        0.0
      ],
      "plane_d": 70.106201171875,
      "bbox_min": [
        -3401.10009765625,
        -3301.958984375,
        1195.0
      ],
      "bbox_max": [
        -3399.5,
        -3299.55908203125,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6804140210151672,
        -0.6804131865501404,
        0.2721666097640991
      ],
      "plane_d": -258.54150390625,
      "bbox_min": [
        -3401.10009765625,
        -3301.958984375,
        1197.800048828125
      ],
      "bbox_max": [
        -3399.5,
        -3299.55908203125,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3568912744522095,
        -0.9341459274291992,
        0.0
      ],
      "plane_d": -1862.1444091796875,
      "bbox_min": [
        -3433.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3395.568115234375,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3297.35888671875,
      "bbox_min": [
        -3433.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3395.568115234375,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3433.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3395.568115234375,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3433.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3406.3896484375,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8571218848228455,
        -0.5151137113571167,
        -0.0
      ],
      "plane_d": -4623.87158203125,
      "bbox_min": [
        -3413.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3406.3896484375,
        -3297.35888671875,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1199.800048828125,
      "bbox_min": [
        -3413.0,
        -3303.124755859375,
        1199.800048828125
      ],
      "bbox_max": [
        -3406.3896484375,
        -3297.35888671875,
        1199.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1170.0,
      "bbox_min": [
        -3524.0,
        -3305.0,
        1110.0
      ],
      "bbox_max": [
        -3444.0,
        -3101.635986328125,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7444531917572021,
        0.40606623888015747,
        0.5299997329711914
      ],
      "plane_d": -1832.8450927734375,
      "bbox_min": [
        -3474.48876953125,
        -3305.0,
        1110.0
      ],
      "bbox_max": [
        -3444.0,
        -3101.635986328125,
        1152.8251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7794328927993774,
        -0.3340444266796112,
        0.5299988985061646
      ],
      "plane_d": -4326.4423828125,
      "bbox_min": [
        -3457.757568359375,
        -3154.600830078125,
        1110.0
      ],
      "bbox_max": [
        -3444.0,
        -3101.635986328125,
        1143.38232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -3524.0,
        -3305.0,
        1170.0
      ],
      "bbox_max": [
        -3444.0,
        -3115.35888671875,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3255.0,
      "bbox_min": [
        -3524.0,
        -3305.0,
        1170.0
      ],
      "bbox_max": [
        -3444.0,
        -3255.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3275.0,
      "bbox_min": [
        -3489.0,
        -3305.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3265.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3489.0,
      "bbox_min": [
        -3489.0,
        -3275.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3265.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3265.0,
      "bbox_min": [
        -3489.0,
        -3275.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3265.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3479.0,
      "bbox_min": [
        -3479.0,
        -3275.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3265.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3300.0,
      "bbox_min": [
        -3489.0,
        -3305.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3300.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3489.0,
      "bbox_min": [
        -3489.0,
        -3305.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3300.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3479.0,
      "bbox_min": [
        -3479.0,
        -3305.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3300.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3524.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3444.0,
        -3115.35888671875,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3205.0,
      "bbox_min": [
        -3524.0,
        -3205.0,
        1215.0
      ],
      "bbox_max": [
        -3444.0,
        -3205.0,
        1235.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3115.35888671875,
      "bbox_min": [
        -3524.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3444.0,
        -3115.35888671875,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660255074501038,
        -0.4999999701976776,
        0.0
      ],
      "plane_d": 1476.8739013671875,
      "bbox_min": [
        -3524.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3444.0,
        -3115.35888671875,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255074501038,
        -0.4999999701976776,
        -0.0
      ],
      "plane_d": -4557.591796875,
      "bbox_min": [
        -3524.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3444.0,
        -3115.35888671875,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3205.0,
      "bbox_min": [
        -3524.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3444.0,
        -3115.35888671875,
        1215.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8660255074501038,
        0.4999999701976776,
        0.0
      ],
      "plane_d": -1407.5919189453125,
      "bbox_min": [
        -3524.0,
        -3205.0,
        1191.0
      ],
      "bbox_max": [
        -3444.0,
        -3115.35888671875,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255074501038,
        0.4999999701976776,
        0.0
      ],
      "plane_d": 4626.8740234375,
      "bbox_min": [
        -3524.0,
        -3205.0,
        1191.0
      ],
      "bbox_max": [
        -3444.0,
        -3115.35888671875,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3524.0,
        -3205.0,
        1191.0
      ],
      "bbox_max": [
        -3444.0,
        -3115.35888671875,
        1215.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.8698152899742126,
        -0.49337759613990784,
        0.0
      ],
      "plane_d": 1488.474365234375,
      "bbox_min": [
        -3498.0,
        -3162.3408203125,
        1191.0
      ],
      "bbox_max": [
        -3470.0,
        -3137.6591796875,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8698152899742126,
        0.49337759613990784,
        0.0
      ],
      "plane_d": -1464.11962890625,
      "bbox_min": [
        -3498.0,
        -3162.3408203125,
        1191.0
      ],
      "bbox_max": [
        -3470.0,
        -3137.6591796875,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8698152899742126,
        -0.49337759613990784,
        0.0
      ],
      "plane_d": -4572.3984375,
      "bbox_min": [
        -3498.0,
        -3162.3408203125,
        1191.0
      ],
      "bbox_max": [
        -3470.0,
        -3137.6591796875,
        1195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8698152899742126,
        0.49337759613990784,
        -0.0
      ],
      "plane_d": 4596.7529296875,
      "bbox_min": [
        -3498.0,
        -3162.3408203125,
        1191.0
      ],
      "bbox_max": [
        -3477.0,
        -3137.6591796875,
        1195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3137.6591796875,
      "bbox_min": [
        -3491.0,
        -3162.3408203125,
        1191.0
      ],
      "bbox_max": [
        -3477.0,
        -3137.6591796875,
        1195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3162.3408203125,
      "bbox_min": [
        -3491.0,
        -3162.3408203125,
        1191.0
      ],
      "bbox_max": [
        -3477.0,
        -3162.3408203125,
        1195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3184.64111328125,
      "bbox_min": [
        -3504.0,
        -3205.0,
        1195.0
      ],
      "bbox_max": [
        -3464.0,
        -3134.552734375,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3491.0,
      "bbox_min": [
        -3491.0,
        -3205.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3184.64111328125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3477.0,
      "bbox_min": [
        -3491.0,
        -3205.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3184.64111328125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        -3491.0,
        -3205.0,
        1210.0
      ],
      "bbox_max": [
        -3477.0,
        -3184.64111328125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3137.0,
      "bbox_min": [
        -3486.0,
        -3137.0,
        1195.0
      ],
      "bbox_max": [
        -3482.0,
        -3134.552734375,
        1199.8944091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721364974975586,
        0.8944272994995117
      ],
      "plane_d": 329.490966796875,
      "bbox_min": [
        -3486.0,
        -3137.0,
        1195.0
      ],
      "bbox_max": [
        -3482.0,
        -3134.552734375,
        1199.8944091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3486.0,
      "bbox_min": [
        -3486.0,
        -3137.0,
        1195.0
      ],
      "bbox_max": [
        -3482.0,
        -3134.552734375,
        1199.8944091796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3482.0,
      "bbox_min": [
        -3486.0,
        -3137.0,
        1195.0
      ],
      "bbox_max": [
        -3482.0,
        -3134.552734375,
        1199.8944091796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3135.0,
      "bbox_min": [
        -3486.0,
        -3137.0,
        1195.0
      ],
      "bbox_max": [
        -3482.0,
        -3134.552734375,
        1199.8944091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944247364997864,
        0.44721856713294983
      ],
      "plane_d": -3342.025390625,
      "bbox_min": [
        -3486.0,
        -3137.0,
        1199.0
      ],
      "bbox_max": [
        -3482.0,
        -3136.552734375,
        1199.8944091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944247364997864,
        -0.44721856713294983
      ],
      "plane_d": 3339.789306640625,
      "bbox_min": [
        -3486.0,
        -3135.0,
        1198.0
      ],
      "bbox_max": [
        -3482.0,
        -3134.552734375,
        1198.8944091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6298019289970398,
        0.0,
        0.7767557501792908
      ],
      "plane_d": -3127.806396484375,
      "bbox_min": [
        -3511.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3457.0,
        -3205.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6298019289970398,
        0.0,
        0.7767557501792908
      ],
      "plane_d": 1260.653564453125,
      "bbox_min": [
        -3511.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3457.0,
        -3205.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3213.35888671875,
      "bbox_min": [
        -3511.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3457.0,
        -3205.0,
        1195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6188722848892212,
        0.0,
        -0.7854917645454407
      ],
      "plane_d": 3098.5029296875,
      "bbox_min": [
        -3509.0,
        -3213.35888671875,
        1180.0
      ],
      "bbox_max": [
        -3459.0,
        -3205.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3492.5,
        -3213.35888671875,
        1195.0
      ],
      "bbox_max": [
        -3489.96142578125,
        -3205.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6188722848892212,
        0.0,
        -0.7854917645454407
      ],
      "plane_d": -1213.7989501953125,
      "bbox_min": [
        -3492.5,
        -3213.35888671875,
        1180.0
      ],
      "bbox_max": [
        -3459.0,
        -3205.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3478.038330078125,
        -3213.35888671875,
        1195.0
      ],
      "bbox_max": [
        -3475.5,
        -3205.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1193.0,
      "bbox_min": [
        -3492.5,
        -3213.35888671875,
        1193.0
      ],
      "bbox_max": [
        -3475.5,
        -3205.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3489.96142578125,
        -3213.35888671875,
        1195.0
      ],
      "bbox_max": [
        -3478.038330078125,
        -3205.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3265.0,
      "bbox_min": [
        -3489.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3245.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3275.0,
      "bbox_min": [
        -3489.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3265.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3489.0,
      "bbox_min": [
        -3489.0,
        -3275.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3265.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3479.0,
      "bbox_min": [
        -3489.0,
        -3275.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3265.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3489.0,
        -3275.0,
        1195.0
      ],
      "bbox_max": [
        -3479.0,
        -3265.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3300.0,
      "bbox_min": [
        -3489.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3300.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3489.0,
      "bbox_min": [
        -3489.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3300.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3479.0,
      "bbox_min": [
        -3489.0,
        -3305.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3300.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3489.0,
        -3305.0,
        1195.0
      ],
      "bbox_max": [
        -3479.0,
        -3300.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3489.0,
      "bbox_min": [
        -3489.0,
        -3255.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3245.0,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3255.0,
      "bbox_min": [
        -3489.0,
        -3255.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3245.0,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        -3489.0,
        -3255.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3245.0,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3245.0,
      "bbox_min": [
        -3489.0,
        -3255.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3245.0,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3479.0,
      "bbox_min": [
        -3479.0,
        -3255.0,
        1180.0
      ],
      "bbox_max": [
        -3479.0,
        -3245.0,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        -3682.0,
        -3320.0,
        1110.0
      ],
      "bbox_max": [
        -3381.701416015625,
        -3305.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7444531917572021,
        0.40606623888015747,
        0.5299997329711914
      ],
      "plane_d": -1832.8450927734375,
      "bbox_min": [
        -3495.59716796875,
        -3320.0,
        1110.0
      ],
      "bbox_max": [
        -3431.772705078125,
        -3305.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4248773753643036,
        0.7338800430297852,
        0.5299993753433228
      ],
      "plane_d": 362.9822998046875,
      "bbox_min": [
        -3495.59716796875,
        -3320.0,
        1110.0
      ],
      "bbox_max": [
        -3465.484375,
        -3309.06201171875,
        1134.14013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3444.0,
      "bbox_min": [
        -3524.0,
        -3320.0,
        1170.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3524.0,
        -3320.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3310.0,
      "bbox_min": [
        -3489.0,
        -3310.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3489.0,
      "bbox_min": [
        -3489.0,
        -3310.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3479.0,
      "bbox_min": [
        -3479.0,
        -3310.0,
        1170.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3682.0,
      "bbox_min": [
        -3682.0,
        -3320.0,
        1175.0
      ],
      "bbox_max": [
        -3381.701416015625,
        -3305.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1195.0,
      "bbox_min": [
        -3650.0,
        -3320.0,
        1175.0
      ],
      "bbox_max": [
        -3381.701416015625,
        -3305.0,
        1235.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3318.755126953125,
      "bbox_min": [
        -3587.0,
        -3320.0,
        1192.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3587.0,
        -3320.0,
        1192.0
      ],
      "bbox_max": [
        -3444.0,
        -3318.755126953125,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3587.0,
        -3320.0,
        1192.0
      ],
      "bbox_max": [
        -3587.0,
        -3318.755126953125,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3443.999755859375,
      "bbox_min": [
        -3444.0,
        -3320.0,
        1192.0
      ],
      "bbox_max": [
        -3444.0,
        -3318.755126953125,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8816039562225342,
        0.47199007868766785,
        0.0
      ],
      "plane_d": 4650.0185546875,
      "bbox_min": [
        -3587.0,
        -3318.755126953125,
        1192.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3587.0,
        -3318.755126953125,
        1192.0
      ],
      "bbox_max": [
        -3524.0,
        -3305.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3524.0,
        -3318.755126953125,
        1192.0
      ],
      "bbox_max": [
        -3524.0,
        -3305.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8816039562225342,
        0.47199007868766785,
        0.0
      ],
      "plane_d": -1492.99755859375,
      "bbox_min": [
        -3489.0,
        -3318.755126953125,
        1192.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3310.0,
      "bbox_min": [
        -3489.0,
        -3310.0,
        1192.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3489.0,
      "bbox_min": [
        -3489.0,
        -3310.0,
        1192.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3479.0,
      "bbox_min": [
        -3479.0,
        -3310.0,
        1192.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3587.0,
        -3320.0,
        1175.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1192.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3524.0,
        -3320.0,
        1175.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1192.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3443.999755859375,
      "bbox_min": [
        -3489.0,
        -3320.0,
        1175.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1192.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3310.0,
      "bbox_min": [
        -3489.0,
        -3310.0,
        1175.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1192.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3489.0,
      "bbox_min": [
        -3489.0,
        -3310.0,
        1175.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1192.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3479.0,
      "bbox_min": [
        -3479.0,
        -3310.0,
        1175.0
      ],
      "bbox_max": [
        -3479.0,
        -3305.0,
        1192.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.765704870223999,
        0.0,
        -0.6431921124458313
      ],
      "plane_d": -1943.818359375,
      "bbox_min": [
        -3650.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3381.701416015625,
        -3305.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -3555.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3381.701416015625,
        -3305.0,
        1235.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3524.0,
        -3320.0,
        1215.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3443.999755859375,
      "bbox_min": [
        -3444.0,
        -3320.0,
        1215.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8571218848228455,
        -0.5151137113571167,
        -0.0
      ],
      "plane_d": -4623.87158203125,
      "bbox_min": [
        -3555.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3381.999267578125,
        -3305.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8948943018913269,
        -0.4462781548500061,
        0.0
      ],
      "plane_d": 1561.975830078125,
      "bbox_min": [
        -3408.40771484375,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3381.999267578125,
        -3305.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3318.447509765625,
      "bbox_min": [
        -3408.40771484375,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3400.065185546875,
        -3305.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3317.937744140625,
      "bbox_min": [
        -3408.40771484375,
        -3317.937744140625,
        1195.0
      ],
      "bbox_max": [
        -3400.065185546875,
        -3305.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1199.800048828125,
      "bbox_min": [
        -3408.40771484375,
        -3312.0,
        1195.0
      ],
      "bbox_max": [
        -3401.10009765625,
        -3305.0,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3401.10009765625,
      "bbox_min": [
        -3404.200927734375,
        -3312.0,
        1195.0
      ],
      "bbox_max": [
        -3401.10009765625,
        -3305.0,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284762144088745,
        -0.0,
        0.3713918626308441
      ],
      "plane_d": 2712.9873046875,
      "bbox_min": [
        -3404.200927734375,
        -3312.0,
        1195.0
      ],
      "bbox_max": [
        -3401.10009765625,
        -3305.0,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3312.0,
      "bbox_min": [
        -3404.200927734375,
        -3312.0,
        1195.0
      ],
      "bbox_max": [
        -3401.10009765625,
        -3312.0,
        1199.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8025973439216614,
        -0.5965213179588318,
        0.0
      ],
      "plane_d": 740.216064453125,
      "bbox_min": [
        -3400.3193359375,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3381.999267578125,
        -3309.467041015625,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3318.447509765625,
      "bbox_min": [
        -3400.3193359375,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3388.295166015625,
        -3317.937744140625,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3317.937744140625,
      "bbox_min": [
        -3400.065185546875,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3388.295166015625,
        -3317.937744140625,
        1215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1205.0,
      "bbox_min": [
        -3397.85302734375,
        -3318.447509765625,
        1200.837158203125
      ],
      "bbox_max": [
        -3391.435546875,
        -3317.937744140625,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999931454658508,
        0.0037271007895469666,
        0.0
      ],
      "plane_d": -3379.046142578125,
      "bbox_min": [
        -3391.437255859375,
        -3318.447509765625,
        1200.837158203125
      ],
      "bbox_max": [
        -3391.435546875,
        -3317.937744140625,
        1205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3317.937744140625,
      "bbox_min": [
        -3388.674072265625,
        -3320.0,
        1205.30029296875
      ],
      "bbox_max": [
        -3386.85205078125,
        -3317.937744140625,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8140390515327454,
        0.5808102488517761,
        -0.0
      ],
      "plane_d": 4685.31982421875,
      "bbox_min": [
        -3388.3095703125,
        -3320.0,
        1205.8291015625
      ],
      "bbox_max": [
        -3386.85205078125,
        -3317.957275390625,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3318.447509765625,
      "bbox_min": [
        -3388.674072265625,
        -3318.447509765625,
        1205.30029296875
      ],
      "bbox_max": [
        -3388.659423828125,
        -3318.447509765625,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        -3555.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3400.322509765625,
        -3305.0,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3433.0,
      "bbox_min": [
        -3524.0,
        -3320.0,
        1210.0
      ],
      "bbox_max": [
        -3400.322509765625,
        -3305.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3524.0,
      "bbox_min": [
        -3524.0,
        -3320.0,
        1210.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3443.999755859375,
      "bbox_min": [
        -3444.0,
        -3320.0,
        1210.0
      ],
      "bbox_max": [
        -3444.0,
        -3305.0,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8948925137519836,
        0.44628196954727173,
        0.0
      ],
      "plane_d": -1562.47119140625,
      "bbox_min": [
        -3401.668212890625,
        -3320.0,
        1210.0
      ],
      "bbox_max": [
        -3400.322509765625,
        -3317.937744140625,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3317.937744140625,
      "bbox_min": [
        -3401.09375,
        -3320.0,
        1210.0
      ],
      "bbox_max": [
        -3400.322509765625,
        -3317.937744140625,
        1215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8948943018913269,
        -0.4462781548500061,
        0.0
      ],
      "plane_d": 1561.975830078125,
      "bbox_min": [
        -3401.09375,
        -3320.0,
        1210.0
      ],
      "bbox_max": [
        -3400.322509765625,
        -3318.447509765625,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3318.447509765625,
      "bbox_min": [
        -3400.364501953125,
        -3318.447509765625,
        1210.0
      ],
      "bbox_max": [
        -3400.32568359375,
        -3318.447509765625,
        1215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8948943018913269,
        -0.4462781548500061,
        0.0
      ],
      "plane_d": 1561.975830078125,
      "bbox_min": [
        -3401.66796875,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3400.322509765625,
        -3317.937744140625,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3318.447509765625,
      "bbox_min": [
        -3401.66796875,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3400.32568359375,
        -3317.937744140625,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8948912024497986,
        0.44628435373306274,
        0.0
      ],
      "plane_d": -1562.458740234375,
      "bbox_min": [
        -3400.893798828125,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3400.63232421875,
        -3317.937744140625,
        1210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3317.937744140625,
      "bbox_min": [
        -3400.6396484375,
        -3317.937744140625,
        1195.0
      ],
      "bbox_max": [
        -3400.63232421875,
        -3317.937744140625,
        1210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8948912024497986,
        0.44628435373306274,
        0.0
      ],
      "plane_d": -1562.458740234375,
      "bbox_min": [
        -3401.66796875,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3400.893798828125,
        -3318.447509765625,
        1210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3587.0,
      "bbox_min": [
        -3650.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3305.0,
        1235.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3585.0,
      "bbox_min": [
        -3587.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3305.0,
        1235.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3307.0,
      "bbox_min": [
        -3587.0,
        -3318.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3307.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3318.0,
      "bbox_min": [
        -3587.0,
        -3318.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3307.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1211.5,
      "bbox_min": [
        -3587.0,
        -3318.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3307.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1198.5,
      "bbox_min": [
        -3587.0,
        -3318.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3307.0,
        1198.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3307.0,
      "bbox_min": [
        -3585.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3305.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3576.0,
      "bbox_min": [
        -3585.0,
        -3307.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3305.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1211.5,
      "bbox_min": [
        -3585.0,
        -3307.0,
        1211.5
      ],
      "bbox_max": [
        -3576.0,
        -3305.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3318.0,
      "bbox_min": [
        -3585.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3318.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3576.0,
      "bbox_min": [
        -3585.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3576.0,
        -3318.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1211.5,
      "bbox_min": [
        -3585.0,
        -3320.0,
        1211.5
      ],
      "bbox_max": [
        -3576.0,
        -3318.0,
        1211.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1233.0,
      "bbox_min": [
        -3650.0,
        -3316.5,
        1233.0
      ],
      "bbox_max": [
        -3646.5,
        -3308.5,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3646.5,
      "bbox_min": [
        -3650.0,
        -3316.5,
        1233.0
      ],
      "bbox_max": [
        -3646.5,
        -3308.5,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3650.0,
      "bbox_min": [
        -3650.0,
        -3316.5,
        1233.0
      ],
      "bbox_max": [
        -3646.5,
        -3308.5,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3316.5,
      "bbox_min": [
        -3650.0,
        -3316.5,
        1233.0
      ],
      "bbox_max": [
        -3646.5,
        -3308.5,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3308.5,
      "bbox_min": [
        -3650.0,
        -3308.5,
        1233.0
      ],
      "bbox_max": [
        -3646.5,
        -3308.5,
        1235.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.800048828125,
      "bbox_min": [
        -3925.00048828125,
        -3347.5634765625,
        1039.786865234375
      ],
      "bbox_max": [
        -3438.327880859375,
        -3072.300048828125,
        1110.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3072.300048828125,
      "bbox_min": [
        -3925.00048828125,
        -3295.0,
        1039.786865234375
      ],
      "bbox_max": [
        -3531.0,
        -3072.300048828125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1057.0,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3531.0,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9348782896995544,
        0.35496851801872253,
        0.0
      ],
      "plane_d": 4537.2568359375,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3544.30517578125,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4117788076400757,
        0.9112839102745056,
        0.0
      ],
      "plane_d": 1526.0416259765625,
      "bbox_min": [
        -3608.890869140625,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3544.30517578125,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320478200912476,
        -0.554703950881958,
        0.0
      ],
      "plane_d": 1174.0020751953125,
      "bbox_min": [
        -3608.890869140625,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3544.30517578125,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6089512705802917,
        0.7932076454162598,
        0.0
      ],
      "plane_d": 4797.318359375,
      "bbox_min": [
        -3608.890869140625,
        -3283.997314453125,
        1057.0
      ],
      "bbox_max": [
        -3600.33203125,
        -3277.426513671875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6089512705802917,
        0.7932076454162598,
        0.0
      ],
      "plane_d": 4797.318359375,
      "bbox_min": [
        -3600.33203125,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3586.0,
        -3283.997314453125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3072.300048828125,
      "bbox_min": [
        -3925.00048828125,
        -3347.5634765625,
        1059.800048828125
      ],
      "bbox_max": [
        -3438.327880859375,
        -3072.300048828125,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7055787444114685,
        -0.47038400173187256,
        0.5299976468086243
      ],
      "plane_d": 417.880126953125,
      "bbox_min": [
        -3749.5,
        -3344.7880859375,
        1059.800048828125
      ],
      "bbox_max": [
        -3492.66650390625,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8479983806610107,
        -0.0,
        0.5299989581108093
      ],
      "plane_d": 2591.27099609375,
      "bbox_min": [
        -3749.5,
        -3343.21923828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3561.0,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8862254619598389,
        0.4632542133331299,
        -0.0
      ],
      "plane_d": 4831.29833984375,
      "bbox_min": [
        -3737.0,
        -3316.109130859375,
        1059.800048828125
      ],
      "bbox_max": [
        -3718.124755859375,
        -3240.800048828125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3737.0,
      "bbox_min": [
        -3737.0,
        -3280.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3737.0,
        -3240.800048828125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11154443770647049,
        0.9937595129013062,
        -0.0
      ],
      "plane_d": 3717.53271484375,
      "bbox_min": [
        -3749.5,
        -3343.21923828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3561.0,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3728.98388671875,
        -3343.21923828125,
        1090.0
      ],
      "bbox_max": [
        -3633.056884765625,
        -3322.318115234375,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7515174150466919,
        0.39283910393714905,
        0.5299990773200989
      ],
      "plane_d": 3519.23388671875,
      "bbox_min": [
        -3728.98388671875,
        -3335.6806640625,
        1090.0
      ],
      "bbox_max": [
        -3714.0,
        -3322.318115234375,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8479982614517212,
        0.5299989581108093
      ],
      "plane_d": -3243.80517578125,
      "bbox_min": [
        -3749.5,
        -3324.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3561.0,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 275.771728515625,
      "bbox_min": [
        -3749.5,
        -3324.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3561.0,
        -3131.5,
        1110.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.735303521156311,
        -0.4224090576171875,
        0.529999315738678
      ],
      "plane_d": 822.22265625,
      "bbox_min": [
        -3749.5,
        -3324.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3625.0,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1074.9998779296875,
      "bbox_min": [
        -3749.5,
        -3324.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3625.0,
        -3231.46435546875,
        1110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8862254619598389,
        0.4632542133331299,
        -0.0
      ],
      "plane_d": 4831.29833984375,
      "bbox_min": [
        -3727.624755859375,
        -3324.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3668.53564453125,
        -3273.859619140625,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3275.2685546875,
      "bbox_min": [
        -3709.409423828125,
        -3276.677490234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3706.591064453125,
        -3273.859619140625,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3708.000244140625,
      "bbox_min": [
        -3708.000244140625,
        -3276.677490234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3708.000244140625,
        -3275.2685546875,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3708.000244140625,
      "bbox_min": [
        -3708.000244140625,
        -3275.2685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3708.000244140625,
        -3273.859619140625,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7515174150466919,
        0.39283910393714905,
        0.5299990773200989
      ],
      "plane_d": 3519.23388671875,
      "bbox_min": [
        -3749.5,
        -3324.0,
        1075.0
      ],
      "bbox_max": [
        -3700.109619140625,
        -3267.3779296875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8862254619598389,
        0.4632542133331299,
        -0.0
      ],
      "plane_d": 4831.29833984375,
      "bbox_min": [
        -3737.0,
        -3324.0,
        1075.0
      ],
      "bbox_max": [
        -3714.0,
        -3280.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40825355052948,
        -0.40825355052948,
        0.8164912462234497
      ],
      "plane_d": -701.7322998046875,
      "bbox_min": [
        -3715.890869140625,
        -3283.158935546875,
        1075.0
      ],
      "bbox_max": [
        -3700.109619140625,
        -3267.3779296875,
        1085.65185546875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3275.2685546875,
      "bbox_min": [
        -3709.409423828125,
        -3276.677490234375,
        1075.0
      ],
      "bbox_max": [
        -3706.591064453125,
        -3273.859619140625,
        1076.523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3708.000244140625,
      "bbox_min": [
        -3708.000244140625,
        -3276.677490234375,
        1075.0
      ],
      "bbox_max": [
        -3708.000244140625,
        -3275.2685546875,
        1075.8187255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3708.000244140625,
      "bbox_min": [
        -3708.000244140625,
        -3275.2685546875,
        1075.0
      ],
      "bbox_max": [
        -3708.000244140625,
        -3273.859619140625,
        1076.523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082728624343872,
        0.40822625160217285,
        -0.8164952397346497
      ],
      "plane_d": 3729.32763671875,
      "bbox_min": [
        -3715.890869140625,
        -3283.158935546875,
        1075.1141357421875
      ],
      "bbox_max": [
        -3700.109619140625,
        -3267.3779296875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082241356372833,
        0.40828341245651245,
        0.8164910078048706
      ],
      "plane_d": 1972.53662109375,
      "bbox_min": [
        -3715.890869140625,
        -3283.158935546875,
        1075.1142578125
      ],
      "bbox_max": [
        -3700.109619140625,
        -3268.9560546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40826934576034546,
        0.4082441031932831,
        0.8164882063865662
      ],
      "plane_d": -1055.14697265625,
      "bbox_min": [
        -3714.312744140625,
        -3283.158935546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3700.109619140625,
        -3268.9560546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3275.2685546875,
      "bbox_min": [
        -3714.312744140625,
        -3281.5810546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3701.687744140625,
        -3268.9560546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3708.000244140625,
      "bbox_min": [
        -3714.312744140625,
        -3281.5810546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3701.687744140625,
        -3275.268310546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40822869539260864,
        0.4082396328449249,
        0.816510796546936
      ],
      "plane_d": 1968.4600830078125,
      "bbox_min": [
        -3714.312744140625,
        -3281.5810546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3708.000244140625,
        -3275.2685546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4082396328449249,
        0.40822869539260864,
        0.816510796546936
      ],
      "plane_d": -1059.0406494140625,
      "bbox_min": [
        -3708.000244140625,
        -3281.5810546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3701.687744140625,
        -3275.2685546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3708.000244140625,
      "bbox_min": [
        -3714.312744140625,
        -3275.2685546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3701.687744140625,
        -3268.9560546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082440137863159,
        -0.40820634365081787,
        0.816519558429718
      ],
      "plane_d": -705.5723876953125,
      "bbox_min": [
        -3714.312744140625,
        -3275.2685546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3708.000244140625,
        -3268.9560546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082440137863159,
        0.40820634365081787,
        -0.816519558429718
      ],
      "plane_d": 3733.1103515625,
      "bbox_min": [
        -3708.000244140625,
        -3275.2685546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3701.687744140625,
        -3268.9560546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3275.2685546875,
      "bbox_min": [
        -3708.00048828125,
        -3275.2685546875,
        1075.1141357421875
      ],
      "bbox_max": [
        -3706.591064453125,
        -3275.2685546875,
        1076.5235595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1357402354478836,
        -0.8370640873908997,
        0.5299983024597168
      ],
      "plane_d": -2793.858642578125,
      "bbox_min": [
        -3598.0,
        -3231.0,
        1090.0
      ],
      "bbox_max": [
        -3561.0,
        -3213.533203125,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3654.8359375,
        -3344.7880859375,
        1090.0
      ],
      "bbox_max": [
        -3492.66650390625,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -3236.173828125,
      "bbox_min": [
        -3507.68994140625,
        -3135.0,
        1090.0
      ],
      "bbox_max": [
        -3492.66650390625,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09053575247526169,
        0.9958932995796204,
        0.0
      ],
      "plane_d": 2993.927001953125,
      "bbox_min": [
        -3640.858642578125,
        -3347.5634765625,
        1059.800048828125
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07677337527275085,
        0.8445155024528503,
        0.5299994349479675
      ],
      "plane_d": 1961.1470947265625,
      "bbox_min": [
        -3640.858642578125,
        -3347.5634765625,
        1090.0
      ],
      "bbox_max": [
        -3503.90478515625,
        -3324.809814453125,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4248773753643036,
        0.7338800430297852,
        0.5299993753433228
      ],
      "plane_d": 362.9822998046875,
      "bbox_min": [
        -3640.858642578125,
        -3347.5634765625,
        1090.0
      ],
      "bbox_max": [
        -3503.90478515625,
        -3324.809814453125,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3640.858642578125,
        -3347.5634765625,
        1090.0
      ],
      "bbox_max": [
        -3616.0,
        -3335.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.84611976146698,
        0.05640798062086105,
        0.5299997329711914
      ],
      "plane_d": -3318.845703125,
      "bbox_min": [
        -3635.51611328125,
        -3336.7744140625,
        1059.800048828125
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977852702140808,
        0.06651902198791504,
        0.0
      ],
      "plane_d": -3232.49169921875,
      "bbox_min": [
        -3477.55078125,
        -3284.510009765625,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8778955936431885,
        0.47885215282440186,
        0.0
      ],
      "plane_d": -1480.1318359375,
      "bbox_min": [
        -3477.55078125,
        -3284.510009765625,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        -0.39391928911209106,
        0.0
      ],
      "plane_d": -4420.693359375,
      "bbox_min": [
        -3467.583740234375,
        -3170.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3135.0,
      "bbox_min": [
        -3467.583740234375,
        -3135.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3466.0,
        -3135.0,
        1062.3284912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7444531917572021,
        0.40606623888015747,
        0.5299997329711914
      ],
      "plane_d": -1832.8450927734375,
      "bbox_min": [
        -3635.51611328125,
        -3336.7744140625,
        1059.800048828125
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8778955936431885,
        0.47885215282440186,
        0.0
      ],
      "plane_d": -1480.1318359375,
      "bbox_min": [
        -3517.423828125,
        -3318.192626953125,
        1059.800048828125
      ],
      "bbox_max": [
        -3456.0,
        -3245.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5010362863540649,
        0.8654263019561768,
        0.0
      ],
      "plane_d": 1109.2943115234375,
      "bbox_min": [
        -3517.423828125,
        -3318.192626953125,
        1059.800048828125
      ],
      "bbox_max": [
        -3486.0,
        -3300.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5010362863540649,
        0.8654263019561768,
        0.0
      ],
      "plane_d": 1109.2943115234375,
      "bbox_min": [
        -3635.51611328125,
        -3336.7744140625,
        1059.800048828125
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4248773753643036,
        0.7338800430297852,
        0.5299993753433228
      ],
      "plane_d": 362.9822998046875,
      "bbox_min": [
        -3533.5,
        -3327.5,
        1090.0
      ],
      "bbox_max": [
        -3476.704345703125,
        -3300.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.911232590675354,
        -0.4118924140930176,
        0.0
      ],
      "plane_d": 1862.5098876953125,
      "bbox_min": [
        -3635.51611328125,
        -3336.7744140625,
        1059.800048828125
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6824833750724792,
        0.7309011220932007,
        -0.0
      ],
      "plane_d": 4757.7822265625,
      "bbox_min": [
        -3635.51611328125,
        -3336.7744140625,
        1059.800048828125
      ],
      "bbox_max": [
        -3456.5947265625,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -3635.51611328125,
        -3336.7744140625,
        1059.800048828125
      ],
      "bbox_max": [
        -3506.38525390625,
        -3199.9580078125,
        1096.3045654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11154443770647049,
        0.9937595129013062,
        -0.0
      ],
      "plane_d": 3717.53271484375,
      "bbox_min": [
        -3633.056884765625,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3616.0,
        -3333.08544921875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11154443770647049,
        0.9937595129013062,
        -0.0
      ],
      "plane_d": 3717.53271484375,
      "bbox_min": [
        -3633.056884765625,
        -3335.0,
        1080.0
      ],
      "bbox_max": [
        -3616.0,
        -3333.08544921875,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3635.51611328125,
        -3336.7744140625,
        1090.0
      ],
      "bbox_max": [
        -3616.0,
        -3333.08544921875,
        1096.3045654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1069.9998779296875,
      "bbox_min": [
        -3544.30517578125,
        -3235.365966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3456.5947265625,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3135.0,
      "bbox_min": [
        -3534.09814453125,
        -3235.365966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3463.575439453125,
        -3135.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9970060586929321,
        0.07732435315847397,
        -0.0
      ],
      "plane_d": 3746.06005859375,
      "bbox_min": [
        -3534.09814453125,
        -3235.365966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3463.575439453125,
        -3135.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5654605627059937,
        0.8247753381729126,
        -0.0
      ],
      "plane_d": 4625.01171875,
      "bbox_min": [
        -3534.09814453125,
        -3201.865966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3508.9833984375,
        -3184.6474609375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        -0.39391928911209106,
        0.0
      ],
      "plane_d": -4420.693359375,
      "bbox_min": [
        -3466.0,
        -3140.657470703125,
        1062.3284912109375
      ],
      "bbox_max": [
        -3463.575439453125,
        -3135.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -3236.173828125,
      "bbox_min": [
        -3501.0,
        -3140.657470703125,
        1070.0
      ],
      "bbox_max": [
        -3456.5947265625,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3135.0,
      "bbox_min": [
        -3501.0,
        -3140.657470703125,
        1070.0
      ],
      "bbox_max": [
        -3463.575439453125,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        -0.39391928911209106,
        0.0
      ],
      "plane_d": -4420.693359375,
      "bbox_min": [
        -3466.0,
        -3140.657470703125,
        1070.0
      ],
      "bbox_max": [
        -3463.575439453125,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7794328927993774,
        -0.3340444266796112,
        0.5299988985061646
      ],
      "plane_d": -4326.4423828125,
      "bbox_min": [
        -3466.0,
        -3140.657470703125,
        1080.948486328125
      ],
      "bbox_max": [
        -3456.5947265625,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        -0.39391928911209106,
        0.0
      ],
      "plane_d": -4420.693359375,
      "bbox_min": [
        -3466.0,
        -3140.657470703125,
        1080.948486328125
      ],
      "bbox_max": [
        -3463.575439453125,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7794328927993774,
        -0.3340444266796112,
        0.5299988985061646
      ],
      "plane_d": -4326.4423828125,
      "bbox_min": [
        -3515.890869140625,
        -3296.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3438.327880859375,
        -3125.21337890625,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        -0.39391928911209106,
        0.0
      ],
      "plane_d": -4420.693359375,
      "bbox_min": [
        -3463.575439453125,
        -3170.0,
        1066.8013916015625
      ],
      "bbox_max": [
        -3451.0,
        -3140.657470703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3288.2685546875,
      "bbox_min": [
        -3515.890869140625,
        -3296.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3500.109619140625,
        -3280.3779296875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3508.000244140625,
      "bbox_min": [
        -3515.890869140625,
        -3296.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3500.109619140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082241356372833,
        0.40828341245651245,
        0.8164910078048706
      ],
      "plane_d": 1896.199462890625,
      "bbox_min": [
        -3515.890869140625,
        -3296.158935546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3508.000244140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40822869539260864,
        0.4082396328449249,
        0.816510796546936
      ],
      "plane_d": 1892.121337890625,
      "bbox_min": [
        -3514.312744140625,
        -3294.5810546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3508.000244140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40826934576034546,
        0.4082441031932831,
        0.8164882063865662
      ],
      "plane_d": -968.1860961914062,
      "bbox_min": [
        -3508.000244140625,
        -3296.158935546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3500.109619140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4082396328449249,
        0.40822869539260864,
        0.816510796546936
      ],
      "plane_d": -972.085693359375,
      "bbox_min": [
        -3508.000244140625,
        -3294.5810546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3501.687744140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3508.000244140625,
      "bbox_min": [
        -3515.890869140625,
        -3288.2685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3500.109619140625,
        -3280.3779296875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40825355052948,
        -0.40825355052948,
        0.8164912462234497
      ],
      "plane_d": -788.6904296875,
      "bbox_min": [
        -3515.890869140625,
        -3288.2685546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3508.000244140625,
        -3280.3779296875,
        1085.65185546875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4082440137863159,
        -0.40820634365081787,
        0.816519558429718
      ],
      "plane_d": -792.528076171875,
      "bbox_min": [
        -3514.312744140625,
        -3288.2685546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3508.000244140625,
        -3281.9560546875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40822625160217285,
        -0.4082728624343872,
        0.8164952397346497
      ],
      "plane_d": -3652.9697265625,
      "bbox_min": [
        -3508.000244140625,
        -3288.2685546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3500.109619140625,
        -3280.3779296875,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        -0.4082396328449249,
        0.816510796546936
      ],
      "plane_d": -3656.814453125,
      "bbox_min": [
        -3508.000244140625,
        -3288.2685546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3501.687744140625,
        -3281.9560546875,
        1085.65185546875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: lauch1",
      "entity_class": "CSlidingDoor",
      "piece_name": "lauch1",
      "offset": 503,
      "centroid": [
        -3488.0,
        -3150.0,
        1192.4285714285713
      ],
      "bbox_min": [
        -3498.0,
        -3162.3408203125,
        1191.0
      ],
      "bbox_max": [
        -3484.0,
        -3137.6591796875,
        1193.0
      ],
      "dimensions_source": {
        "span_x": 14.0,
        "span_y": 24.681640625,
        "height_z": 2.0,
        "door_width": 24.681640625,
        "door_depth": 14.0,
        "leaf_depth": 13.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3491.0,
          -3162.3408203125,
          1193.0
        ],
        [
          -3498.0,
          -3150.0,
          1193.0
        ],
        [
          -3491.0,
          -3137.6591796875,
          1193.0
        ],
        [
          -3484.0,
          -3137.6591796875,
          1193.0
        ],
        [
          -3484.0,
          -3162.3408203125,
          1193.0
        ],
        [
          -3484.0,
          -3162.3408203125,
          1191.0
        ],
        [
          -3484.0,
          -3137.6591796875,
          1191.0
        ]
      ],
      "plane_distance": 3484.0,
      "authentic_texture": "spkgums1"
    },
    {
      "tag": "CSlidingDoor piece: launch2",
      "entity_class": "CSlidingDoor",
      "piece_name": "launch2",
      "offset": 1311,
      "centroid": [
        -3480.0,
        -3150.0,
        1192.4285714285713
      ],
      "bbox_min": [
        -3484.0,
        -3162.3408203125,
        1191.0
      ],
      "bbox_max": [
        -3470.0,
        -3137.6591796875,
        1193.0
      ],
      "dimensions_source": {
        "span_x": 14.0,
        "span_y": 24.681640625,
        "height_z": 2.0,
        "door_width": 24.681640625,
        "door_depth": 14.0,
        "leaf_depth": 13.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": 1,
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3470.0,
          -3150.0,
          1193.0
        ],
        [
          -3477.0,
          -3162.3408203125,
          1193.0
        ],
        [
          -3477.0,
          -3137.6591796875,
          1193.0
        ],
        [
          -3484.0,
          -3137.6591796875,
          1193.0
        ],
        [
          -3484.0,
          -3162.3408203125,
          1193.0
        ],
        [
          -3484.0,
          -3162.3408203125,
          1191.0
        ],
        [
          -3484.0,
          -3137.6591796875,
          1191.0
        ]
      ],
      "plane_distance": -3484.0,
      "authentic_texture": "spkgums1"
    },
    {
      "tag": "CSlidingDoor piece: launchdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "launchdr",
      "offset": 2121,
      "centroid": [
        -3484.0,
        -3204.0,
        1202.5
      ],
      "bbox_min": [
        -3491.0,
        -3205.0,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3203.0,
        1210.0
      ],
      "dimensions_source": {
        "span_x": 14.0,
        "span_y": 2.0,
        "height_z": 15.0,
        "door_width": 14.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_direction": -1,
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3491.0,
          -3203.0,
          1195.0
        ],
        [
          -3477.0,
          -3203.0,
          1210.0
        ],
        [
          -3491.0,
          -3203.0,
          1210.0
        ],
        [
          -3477.0,
          -3203.0,
          1195.0
        ],
        [
          -3491.0,
          -3205.0,
          1195.0
        ],
        [
          -3477.0,
          -3205.0,
          1210.0
        ],
        [
          -3491.0,
          -3205.0,
          1210.0
        ],
        [
          -3477.0,
          -3205.0,
          1195.0
        ]
      ],
      "plane_distance": 3203.0,
      "authentic_texture": "traindoor1-4"
    },
    {
      "tag": "CSlidingDoor piece: swimdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "swimdr",
      "offset": 3220,
      "centroid": [
        -3484.0,
        -3330.699951171875,
        1202.5
      ],
      "bbox_min": [
        -3491.0,
        -3331.699951171875,
        1195.0
      ],
      "bbox_max": [
        -3477.0,
        -3329.699951171875,
        1210.0
      ],
      "dimensions_source": {
        "span_x": 14.0,
        "span_y": 2.0,
        "height_z": 15.0,
        "door_width": 14.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_direction": -1,
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3491.0,
          -3329.699951171875,
          1195.0
        ],
        [
          -3477.0,
          -3329.699951171875,
          1210.0
        ],
        [
          -3491.0,
          -3329.699951171875,
          1210.0
        ],
        [
          -3477.0,
          -3329.699951171875,
          1195.0
        ],
        [
          -3491.0,
          -3331.699951171875,
          1195.0
        ],
        [
          -3477.0,
          -3331.699951171875,
          1210.0
        ],
        [
          -3491.0,
          -3331.699951171875,
          1210.0
        ],
        [
          -3477.0,
          -3331.699951171875,
          1195.0
        ]
      ],
      "plane_distance": 3329.7,
      "authentic_texture": "traindoor1-3"
    },
    {
      "tag": "CSlidingDoor piece: targetdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "targetdr",
      "offset": 4305,
      "centroid": [
        -3525.0,
        -3312.5,
        1202.5
      ],
      "bbox_min": [
        -3526.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3524.0,
        -3305.0,
        1210.0
      ],
      "dimensions_source": {
        "span_x": 2.0,
        "span_y": 15.0,
        "height_z": 15.0,
        "door_width": 15.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": 1,
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3526.0,
          -3320.0,
          1195.0
        ],
        [
          -3526.0,
          -3305.0,
          1210.0
        ],
        [
          -3526.0,
          -3320.0,
          1210.0
        ],
        [
          -3526.0,
          -3305.0,
          1195.0
        ],
        [
          -3524.0,
          -3320.0,
          1195.0
        ],
        [
          -3524.0,
          -3305.0,
          1210.0
        ],
        [
          -3524.0,
          -3320.0,
          1210.0
        ],
        [
          -3524.0,
          -3305.0,
          1195.0
        ]
      ],
      "plane_distance": -3526.0,
      "authentic_texture": "traindoor1-1"
    },
    {
      "tag": "CSlidingDoor piece: circutdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "circutdr",
      "offset": 5386,
      "centroid": [
        -3443.0,
        -3312.5,
        1202.5
      ],
      "bbox_min": [
        -3444.0,
        -3320.0,
        1195.0
      ],
      "bbox_max": [
        -3442.0,
        -3305.0,
        1210.0
      ],
      "dimensions_source": {
        "span_x": 2.0,
        "span_y": 15.0,
        "height_z": 15.0,
        "door_width": 15.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": 1,
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3444.0,
          -3320.0,
          1195.0
        ],
        [
          -3444.0,
          -3305.0,
          1210.0
        ],
        [
          -3444.0,
          -3320.0,
          1210.0
        ],
        [
          -3444.0,
          -3305.0,
          1195.0
        ],
        [
          -3442.0,
          -3320.0,
          1195.0
        ],
        [
          -3442.0,
          -3305.0,
          1210.0
        ],
        [
          -3442.0,
          -3320.0,
          1210.0
        ],
        [
          -3442.0,
          -3305.0,
          1195.0
        ]
      ],
      "plane_distance": -3444.0,
      "authentic_texture": "traindoor1-2"
    },
    {
      "tag": "CSlidingDoor piece: win1",
      "entity_class": "CSlidingDoor",
      "piece_name": "win1",
      "offset": 6473,
      "centroid": [
        -3585.0,
        -3282.5,
        1205.0
      ],
      "bbox_min": [
        -3585.0,
        -3288.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3277.0,
        1211.5
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 11.0,
        "height_z": 13.0,
        "door_width": 11.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3585.0,
          -3288.0,
          1198.5
        ],
        [
          -3585.0,
          -3288.0,
          1211.5
        ],
        [
          -3585.0,
          -3277.0,
          1211.5
        ],
        [
          -3585.0,
          -3277.0,
          1198.5
        ]
      ],
      "plane_distance": 3585.0,
      "authentic_texture": "trainfire1-1"
    },
    {
      "tag": "CSlidingDoor piece: win2",
      "entity_class": "CSlidingDoor",
      "piece_name": "win2",
      "offset": 7159,
      "centroid": [
        -3585.0,
        -3297.5,
        1205.0
      ],
      "bbox_min": [
        -3585.0,
        -3303.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3292.0,
        1211.5
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 11.0,
        "height_z": 13.0,
        "door_width": 11.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3585.0,
          -3303.0,
          1211.5
        ],
        [
          -3585.0,
          -3303.0,
          1198.5
        ],
        [
          -3585.0,
          -3292.0,
          1211.5
        ],
        [
          -3585.0,
          -3292.0,
          1198.5
        ]
      ],
      "plane_distance": 3585.0,
      "authentic_texture": "trainfire1-2"
    },
    {
      "tag": "CSlidingDoor piece: win3",
      "entity_class": "CSlidingDoor",
      "piece_name": "win3",
      "offset": 7847,
      "centroid": [
        -3585.0,
        -3312.5,
        1205.0
      ],
      "bbox_min": [
        -3585.0,
        -3318.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3307.0,
        1211.5
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 11.0,
        "height_z": 13.0,
        "door_width": 11.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3585.0,
          -3318.0,
          1211.5
        ],
        [
          -3585.0,
          -3318.0,
          1198.5
        ],
        [
          -3585.0,
          -3307.0,
          1211.5
        ],
        [
          -3585.0,
          -3307.0,
          1198.5
        ]
      ],
      "plane_distance": 3585.0,
      "authentic_texture": "trainfire1-3"
    },
    {
      "tag": "CSlidingDoor piece: win4",
      "entity_class": "CSlidingDoor",
      "piece_name": "win4",
      "offset": 8535,
      "centroid": [
        -3585.0,
        -3327.5,
        1205.0
      ],
      "bbox_min": [
        -3585.0,
        -3333.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3322.0,
        1211.5
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 11.0,
        "height_z": 13.0,
        "door_width": 11.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3585.0,
          -3333.0,
          1198.5
        ],
        [
          -3585.0,
          -3333.0,
          1211.5
        ],
        [
          -3585.0,
          -3322.0,
          1211.5
        ],
        [
          -3585.0,
          -3322.0,
          1198.5
        ]
      ],
      "plane_distance": 3585.0,
      "authentic_texture": "trainfire1-4"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 9189,
      "centroid": [
        -3623.050048828125,
        -3344.39990234375,
        1208.0
      ],
      "bbox_min": [
        -3625.300048828125,
        -3346.89990234375,
        1205.25
      ],
      "bbox_max": [
        -3620.800048828125,
        -3341.89990234375,
        1210.75
      ],
      "dimensions_source": {
        "span_x": 4.5,
        "span_y": 5.0,
        "height_z": 5.5,
        "door_width": 5.0,
        "door_depth": 4.5,
        "leaf_depth": 4.5,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_direction": 1,
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3625.300048828125,
          -3346.89990234375,
          1205.25
        ],
        [
          -3625.300048828125,
          -3341.89990234375,
          1210.75
        ],
        [
          -3625.300048828125,
          -3346.89990234375,
          1210.75
        ],
        [
          -3625.300048828125,
          -3341.89990234375,
          1205.25
        ],
        [
          -3620.800048828125,
          -3346.89990234375,
          1205.25
        ],
        [
          -3620.800048828125,
          -3341.89990234375,
          1210.75
        ],
        [
          -3620.800048828125,
          -3346.89990234375,
          1210.75
        ],
        [
          -3620.800048828125,
          -3341.89990234375,
          1205.25
        ]
      ],
      "plane_distance": -3625.3,
      "authentic_texture": "chkcrate-s_h"
    },
    {
      "tag": "CSlidingDoor piece: circdr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "circdr1",
      "offset": 10355,
      "centroid": [
        -3404.00927734375,
        -3325.2705078125,
        1200.0
      ],
      "bbox_min": [
        -3405.703125,
        -3328.317138671875,
        1195.0
      ],
      "bbox_max": [
        -3402.3154296875,
        -3322.223876953125,
        1205.0
      ],
      "dimensions_source": {
        "span_x": 3.3876953125,
        "span_y": 6.09326171875,
        "height_z": 10.0,
        "door_width": 6.09326171875,
        "door_depth": 3.3876953125,
        "leaf_depth": 3.3476953125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          0.8949,
          -0.4463,
          0.0
        ]
      },
      "vertices": [
        [
          -3402.3154296875,
          -3322.44970703125,
          1205.0
        ],
        [
          -3405.241455078125,
          -3328.317138671875,
          1205.0
        ],
        [
          -3405.703125,
          -3328.09130859375,
          1205.0
        ],
        [
          -3402.777099609375,
          -3322.223876953125,
          1205.0
        ],
        [
          -3402.3154296875,
          -3322.44970703125,
          1195.0
        ],
        [
          -3402.777099609375,
          -3322.223876953125,
          1195.0
        ],
        [
          -3405.703125,
          -3328.09130859375,
          1195.0
        ],
        [
          -3405.241455078125,
          -3328.317138671875,
          1195.0
        ]
      ],
      "plane_distance": 1561.9662,
      "authentic_texture": "spkdoor1"
    },
    {
      "tag": "CSlidingDoor piece: circdr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "circdr2",
      "offset": 11428,
      "centroid": [
        -3403.79443359375,
        -3339.07568359375,
        1200.0
      ],
      "bbox_min": [
        -3405.435791015625,
        -3342.06396484375,
        1195.0
      ],
      "bbox_max": [
        -3402.153076171875,
        -3336.08740234375,
        1205.0
      ],
      "dimensions_source": {
        "span_x": 3.28271484375,
        "span_y": 5.9765625,
        "height_z": 10.0,
        "door_width": 5.9765625,
        "door_depth": 3.28271484375,
        "leaf_depth": 3.24271484375,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          0.8971,
          0.4418,
          0.0
        ]
      },
      "vertices": [
        [
          -3404.9873046875,
          -3336.08740234375,
          1205.0
        ],
        [
          -3402.153076171875,
          -3341.843017578125,
          1205.0
        ],
        [
          -3402.6015625,
          -3342.06396484375,
          1205.0
        ],
        [
          -3405.435791015625,
          -3336.308349609375,
          1205.0
        ],
        [
          -3404.9873046875,
          -3336.08740234375,
          1195.0
        ],
        [
          -3405.435791015625,
          -3336.308349609375,
          1195.0
        ],
        [
          -3402.6015625,
          -3342.06396484375,
          1195.0
        ],
        [
          -3402.153076171875,
          -3341.843017578125,
          1195.0
        ]
      ],
      "plane_distance": 4528.5039,
      "authentic_texture": "spkdoor1nkd"
    },
    {
      "tag": "CSlidingDoor piece: circdr3",
      "entity_class": "CSlidingDoor",
      "piece_name": "circdr3",
      "offset": 12537,
      "centroid": [
        -3394.644287109375,
        -3345.807373046875,
        1200.0
      ],
      "bbox_min": [
        -3397.85302734375,
        -3346.062255859375,
        1195.0
      ],
      "bbox_max": [
        -3391.435546875,
        -3345.552490234375,
        1205.0
      ],
      "dimensions_source": {
        "span_x": 6.41748046875,
        "span_y": 0.509765625,
        "height_z": 10.0,
        "door_width": 6.41748046875,
        "door_depth": 0.509765625,
        "leaf_depth": 0.469765625,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_direction": -1,
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3397.85302734375,
          -3345.552490234375,
          1205.0
        ],
        [
          -3391.4375,
          -3345.552490234375,
          1205.0
        ],
        [
          -3391.435546875,
          -3346.062255859375,
          1205.0
        ],
        [
          -3397.85107421875,
          -3346.062255859375,
          1205.0
        ],
        [
          -3397.85302734375,
          -3345.552490234375,
          1195.0
        ],
        [
          -3397.85107421875,
          -3346.062255859375,
          1195.0
        ],
        [
          -3391.435546875,
          -3346.062255859375,
          1195.0
        ],
        [
          -3391.4375,
          -3345.552490234375,
          1195.0
        ]
      ],
      "plane_distance": 3345.5525,
      "authentic_texture": "spkdoor1nkd"
    },
    {
      "tag": "CSlidingDoor piece: circdr5",
      "entity_class": "CSlidingDoor",
      "piece_name": "circdr5",
      "offset": 13654,
      "centroid": [
        -3383.71044921875,
        -3324.88818359375,
        1197.0
      ],
      "bbox_min": [
        -3386.033935546875,
        -3327.983154296875,
        1195.0
      ],
      "bbox_max": [
        -3381.386962890625,
        -3321.793212890625,
        1199.0
      ],
      "dimensions_source": {
        "span_x": 4.64697265625,
        "span_y": 6.18994140625,
        "height_z": 4.0,
        "door_width": 6.18994140625,
        "door_depth": 4.64697265625,
        "leaf_depth": 4.60697265625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": 1,
        "slide_vector": [
          -0.814,
          -0.5808,
          -0.0
        ]
      },
      "vertices": [
        [
          -3381.84814453125,
          -3327.983154296875,
          1199.0
        ],
        [
          -3381.386962890625,
          -3327.659912109375,
          1199.0
        ],
        [
          -3385.57275390625,
          -3321.793212890625,
          1199.0
        ],
        [
          -3386.033935546875,
          -3322.116455078125,
          1199.0
        ],
        [
          -3381.84814453125,
          -3327.983154296875,
          1195.0
        ],
        [
          -3381.386962890625,
          -3327.659912109375,
          1195.0
        ],
        [
          -3385.57275390625,
          -3321.793212890625,
          1195.0
        ],
        [
          -3386.033935546875,
          -3322.116455078125,
          1195.0
        ]
      ],
      "plane_distance": -4685.8843,
      "authentic_texture": "spkdoor1nkd"
    },
    {
      "tag": "CSlidingDoor piece: circdr6",
      "entity_class": "CSlidingDoor",
      "piece_name": "circdr6",
      "offset": 14775,
      "centroid": [
        -3394.644287109375,
        -3318.192626953125,
        1200.0
      ],
      "bbox_min": [
        -3397.85302734375,
        -3318.447509765625,
        1195.0
      ],
      "bbox_max": [
        -3391.435546875,
        -3317.937744140625,
        1205.0
      ],
      "dimensions_source": {
        "span_x": 6.41748046875,
        "span_y": 0.509765625,
        "height_z": 10.0,
        "door_width": 6.41748046875,
        "door_depth": 0.509765625,
        "leaf_depth": 0.469765625,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_direction": 1,
        "slide_vector": [
          0.0,
          -1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -3397.85107421875,
          -3317.937744140625,
          1205.0
        ],
        [
          -3397.85302734375,
          -3318.447509765625,
          1205.0
        ],
        [
          -3391.4375,
          -3318.447509765625,
          1205.0
        ],
        [
          -3391.435546875,
          -3317.937744140625,
          1205.0
        ],
        [
          -3397.85302734375,
          -3318.447509765625,
          1195.0
        ],
        [
          -3391.4375,
          -3318.447509765625,
          1195.0
        ],
        [
          -3391.435546875,
          -3317.937744140625,
          1195.0
        ],
        [
          -3397.85107421875,
          -3317.937744140625,
          1195.0
        ]
      ],
      "plane_distance": -3318.4475,
      "authentic_texture": "spkdoor1nkd"
    },
    {
      "tag": "CSlidingDoor piece: circdr4",
      "entity_class": "CSlidingDoor",
      "piece_name": "circdr4",
      "offset": 15856,
      "centroid": [
        -3383.71044921875,
        -3339.11181640625,
        1200.0
      ],
      "bbox_min": [
        -3386.033935546875,
        -3342.206787109375,
        1195.0
      ],
      "bbox_max": [
        -3381.386962890625,
        -3336.016845703125,
        1205.0
      ],
      "dimensions_source": {
        "span_x": 4.64697265625,
        "span_y": 6.18994140625,
        "height_z": 10.0,
        "door_width": 6.18994140625,
        "door_depth": 4.64697265625,
        "leaf_depth": 4.60697265625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": 1,
        "slide_vector": [
          -0.814,
          0.5808,
          0.0
        ]
      },
      "vertices": [
        [
          -3381.84814453125,
          -3336.016845703125,
          1205.0
        ],
        [
          -3381.386962890625,
          -3336.340087890625,
          1205.0
        ],
        [
          -3385.57275390625,
          -3342.206787109375,
          1205.0
        ],
        [
          -3386.033935546875,
          -3341.883544921875,
          1205.0
        ],
        [
          -3381.84814453125,
          -3336.016845703125,
          1195.0
        ],
        [
          -3386.033935546875,
          -3341.883544921875,
          1195.0
        ],
        [
          -3385.57275390625,
          -3342.206787109375,
          1195.0
        ],
        [
          -3381.386962890625,
          -3336.340087890625,
          1195.0
        ]
      ],
      "plane_distance": -815.354,
      "authentic_texture": "spkdoor1nkd"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 16929,
      "centroid": [
        -3609.0,
        -3283.0977783203125,
        1204.25
      ],
      "bbox_min": [
        -3609.0,
        -3286.0,
        1197.0
      ],
      "bbox_max": [
        -3609.0,
        -3280.195556640625,
        1211.5
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 5.804443359375,
        "height_z": 14.5,
        "door_width": 5.804443359375,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3609.0,
          -3286.0,
          1197.0
        ],
        [
          -3609.0,
          -3280.195556640625,
          1211.5
        ],
        [
          -3609.0,
          -3286.0,
          1211.5
        ],
        [
          -3609.0,
          -3280.195556640625,
          1197.0
        ]
      ],
      "plane_distance": 3609.0,
      "authentic_texture": "traintarmp1"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 17594,
      "centroid": [
        -3640.0,
        -3298.0977783203125,
        1184.25
      ],
      "bbox_min": [
        -3640.0,
        -3301.0,
        1177.0
      ],
      "bbox_max": [
        -3640.0,
        -3295.195556640625,
        1191.5
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 5.804443359375,
        "height_z": 14.5,
        "door_width": 5.804443359375,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3640.0,
          -3301.0,
          1177.0
        ],
        [
          -3640.0,
          -3295.195556640625,
          1191.5
        ],
        [
          -3640.0,
          -3301.0,
          1191.5
        ],
        [
          -3640.0,
          -3295.195556640625,
          1177.0
        ]
      ],
      "plane_distance": 3640.0,
      "authentic_texture": "traintarmp1"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 18259,
      "centroid": [
        -3648.0,
        -3312.5977783203125,
        1225.75
      ],
      "bbox_min": [
        -3648.0,
        -3315.5,
        1218.5
      ],
      "bbox_max": [
        -3648.0,
        -3309.695556640625,
        1233.0
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 5.804443359375,
        "height_z": 14.5,
        "door_width": 5.804443359375,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3648.0,
          -3315.5,
          1233.0
        ],
        [
          -3648.0,
          -3309.695556640625,
          1218.5
        ],
        [
          -3648.0,
          -3315.5,
          1218.5
        ],
        [
          -3648.0,
          -3309.695556640625,
          1233.0
        ]
      ],
      "plane_distance": 3648.0,
      "authentic_texture": "traintarcrim"
    },
    {
      "tag": "CSlidingDoor piece: mvtarget",
      "entity_class": "CSlidingDoor",
      "piece_name": "mvtarget",
      "offset": 18960,
      "centroid": [
        -3674.97607421875,
        -3332.062052408854,
        1195.537618001302
      ],
      "bbox_min": [
        -3675.215087890625,
        -3332.630859375,
        1195.0
      ],
      "bbox_max": [
        -3674.713134765625,
        -3331.48388671875,
        1197.365478515625
      ],
      "dimensions_source": {
        "span_x": 0.501953125,
        "span_y": 1.14697265625,
        "height_z": 2.365478515625,
        "door_width": 1.14697265625,
        "door_depth": 0.501953125,
        "leaf_depth": 0.461953125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3675.215087890625,
          -3332.630859375,
          1195.0
        ],
        [
          -3675.215087890625,
          -3331.48388671875,
          1195.2867431640625
        ],
        [
          -3675.215087890625,
          -3332.630859375,
          1195.2867431640625
        ],
        [
          -3675.215087890625,
          -3331.48388671875,
          1195.0
        ],
        [
          -3674.713134765625,
          -3332.630859375,
          1195.0
        ],
        [
          -3674.713134765625,
          -3331.48388671875,
          1195.2867431640625
        ],
        [
          -3674.713134765625,
          -3332.630859375,
          1195.2867431640625
        ],
        [
          -3674.713134765625,
          -3331.48388671875,
          1195.0
        ],
        [
          -3675.0,
          -3332.487548828125,
          1195.2867431640625
        ],
        [
          -3675.0,
          -3331.6552734375,
          1197.365478515625
        ],
        [
          -3675.0,
          -3332.487548828125,
          1197.365478515625
        ],
        [
          -3675.0,
          -3331.6552734375,
          1195.2867431640625
        ]
      ],
      "plane_distance": 3675.0,
      "authentic_texture": "traintarcrim"
    },
    {
      "tag": "CSlidingDoor piece: win5",
      "entity_class": "CSlidingDoor",
      "piece_name": "win5",
      "offset": 20729,
      "centroid": [
        -3585.0,
        -3342.5,
        1205.0
      ],
      "bbox_min": [
        -3585.0,
        -3348.0,
        1198.5
      ],
      "bbox_max": [
        -3585.0,
        -3337.0,
        1211.5
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 11.0,
        "height_z": 13.0,
        "door_width": 11.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": -1,
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3585.0,
          -3348.0,
          1198.5
        ],
        [
          -3585.0,
          -3348.0,
          1211.5
        ],
        [
          -3585.0,
          -3337.0,
          1211.5
        ],
        [
          -3585.0,
          -3337.0,
          1198.5
        ]
      ],
      "plane_distance": 3585.0,
      "authentic_texture": "trainfire1-5"
    },
    {
      "tag": "CElevator piece: ",
      "entity_class": "CElevator",
      "piece_name": "",
      "offset": 21381,
      "centroid": [
        -3364.956689453125,
        -3348.633544921875,
        1196.2
      ],
      "bbox_min": [
        -3374.214111328125,
        -3353.8759765625,
        1195.0
      ],
      "bbox_max": [
        -3360.880126953125,
        -3340.669921875,
        1199.0
      ],
      "dimensions_source": {
        "span_x": 13.333984375,
        "span_y": 13.2060546875,
        "height_z": 4.0,
        "door_width": 13.333984375,
        "door_depth": 13.2060546875,
        "leaf_depth": 13.2060546875,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_direction": 1,
        "slide_vector": [
          -0.866,
          0.5,
          0.0
        ]
      },
      "vertices": [
        [
          -3369.464111328125,
          -3340.669921875,
          1195.0
        ],
        [
          -3374.214111328125,
          -3348.897216796875,
          1195.0
        ],
        [
          -3364.229736328125,
          -3351.272705078125,
          1195.0
        ],
        [
          -3363.229736328125,
          -3349.54052734375,
          1199.0
        ],
        [
          -3363.229736328125,
          -3349.54052734375,
          1195.0
        ],
        [
          -3364.229736328125,
          -3351.272705078125,
          1199.0
        ],
        [
          -3362.229736328125,
          -3347.80859375,
          1195.0
        ],
        [
          -3362.229736328125,
          -3347.80859375,
          1199.0
        ],
        [
          -3365.630126953125,
          -3353.8759765625,
          1195.0
        ],
        [
          -3360.880126953125,
          -3345.648681640625,
          1195.0
        ]
      ],
      "plane_distance": -1237.738,
      "authentic_texture": "cbaseelevpaneldown"
    },
    {
      "tag": "CSlidingDoor piece: rech1",
      "entity_class": "CSlidingDoor",
      "piece_name": "rech1",
      "offset": 22957,
      "centroid": [
        -3363.3192138671875,
        -3314.400146484375,
        1199.0
      ],
      "bbox_min": [
        -3364.06982421875,
        -3315.7001953125,
        1198.0
      ],
      "bbox_max": [
        -3362.568603515625,
        -3313.10009765625,
        1200.0
      ],
      "dimensions_source": {
        "span_x": 1.501220703125,
        "span_y": 2.60009765625,
        "height_z": 2.0,
        "door_width": 2.60009765625,
        "door_depth": 1.501220703125,
        "leaf_depth": 1.461220703125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_direction": 1,
        "slide_vector": [
          -0.866,
          -0.5,
          0.0
        ]
      },
      "vertices": [
        [
          -3362.568603515625,
          -3315.7001953125,
          1198.0
        ],
        [
          -3362.568603515625,
          -3315.7001953125,
          1200.0
        ],
        [
          -3364.06982421875,
          -3313.10009765625,
          1200.0
        ],
        [
          -3364.06982421875,
          -3313.10009765625,
          1198.0
        ]
      ],
      "plane_distance": -4569.939
    }
  ],
  "tutorial_messages": [
    {
      "text": "training door 2 unlocked",
      "nearby_tags": []
    },
    {
      "text": "try going down",
      "nearby_tags": [
        "training"
      ]
    },
    {
      "text": "dropship in position",
      "nearby_tags": [
        "training",
        "launch"
      ]
    },
    {
      "text": "msg-take aim and then fire",
      "nearby_tags": [
        "training",
        "win1"
      ]
    },
    {
      "text": "msg-try using the zoom feature",
      "nearby_tags": [
        "training",
        "mvtarget"
      ]
    },
    {
      "text": "msg-some objects are breakable",
      "nearby_tags": [
        "training",
        "win5"
      ]
    },
    {
      "text": "training door 4 now open",
      "nearby_tags": [
        "launch"
      ]
    },
    {
      "text": "try holding jump longer, now",
      "nearby_tags": []
    }
  ]
}